var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebDevBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    width: "24rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_10_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 249.86,
    cy: 362.362,
    rx: 224.226,
    ry: 124.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_10_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M451.688,343.148l-124.992,72.202c-0.927,0.535-2.431,0.535-3.358,0L143.117,311.3 c-0.927-0.535-0.927-1.404,0-1.939l124.992-72.202c0.927-0.536,2.431-0.536,3.358,0l180.22,104.05 C452.615,341.745,452.615,342.613,451.688,343.148z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_9_",
    style: {
      fill: "#E6E6E6"
    },
    cx: 161.23,
    cy: 412.394,
    rx: 75.083,
    ry: 43.349
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_8_",
    style: {
      fill: "#E6E6E6"
    },
    cx: 252.653,
    cy: 362.135,
    rx: 59.1,
    ry: 34.121
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_5_",
    style: {
      fill: "#E6E6E6"
    },
    cx: 384.088,
    cy: 407.865,
    rx: 37.097,
    ry: 21.418
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3957_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3960_",
    style: {
      fill: "#37474F"
    },
    d: "M329.42,286.365v110.944c0,0.714-0.501,1.582-1.119,1.939l-2.381,1.374 c-0.618,0.357-1.621,0.357-2.239,0l-2.38-1.374c-0.618-0.357-1.119-1.225-1.119-1.939V286.365c0-0.714,0.501-1.003,1.119-0.646 l2.381,1.374c0.618,0.357,1.621,0.357,2.239,0l2.381-1.374C328.919,285.361,329.42,285.651,329.42,286.365z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3959_",
    style: {
      fill: "#455A64"
    },
    d: "M323.681,400.621l-2.38-1.374c-0.618-0.357-1.119-1.225-1.119-1.939V286.365 c0-0.714,0.501-1.003,1.119-0.646l2.381,1.374c0.618,0.357,1.119,1.225,1.119,1.939l0,110.944 C324.8,400.689,324.299,400.978,323.681,400.621z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3954_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3956_",
    style: {
      fill: "#37474F"
    },
    d: "M430.934,227.721v110.944c0,0.714-0.501,1.582-1.12,1.939l-2.381,1.374 c-0.618,0.357-1.621,0.357-2.239,0l-2.38-1.374c-0.618-0.357-1.119-1.225-1.119-1.939V227.721c0-0.714,0.501-1.003,1.12-0.646 l2.381,1.374c0.618,0.357,1.621,0.357,2.239,0l2.381-1.374C430.432,226.717,430.934,227.007,430.934,227.721z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3955_",
    style: {
      fill: "#455A64"
    },
    d: "M425.194,341.977l-2.38-1.374c-0.618-0.357-1.119-1.225-1.119-1.939V227.721 c0-0.714,0.501-1.003,1.12-0.646l2.381,1.374c0.618,0.357,1.119,1.225,1.119,1.939l0,110.944 C426.313,342.045,425.812,342.334,425.194,341.977z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3951_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3953_",
    style: {
      fill: "#37474F"
    },
    d: "M192.708,207.473v110.944c0,0.714-0.501,1.582-1.119,1.939l-2.381,1.374 c-0.618,0.357-1.621,0.357-2.239,0l-2.38-1.374c-0.618-0.357-1.12-1.225-1.12-1.939V207.473c0-0.714,0.501-1.003,1.12-0.646 l2.381,1.374c0.618,0.357,1.621,0.357,2.239,0l2.381-1.374C192.207,206.469,192.708,206.759,192.708,207.473z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3952_",
    style: {
      fill: "#455A64"
    },
    d: "M186.968,321.729l-2.38-1.374c-0.618-0.357-1.12-1.225-1.12-1.939V207.473 c0-0.714,0.501-1.003,1.12-0.646l2.381,1.374c0.618,0.357,1.119,1.225,1.119,1.939l0,110.944 C188.088,321.797,187.587,322.086,186.968,321.729z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3938_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3949_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3950_",
    style: {
      fill: "#27DEBF"
    },
    d: "M453.021,235.612V234.8c0-1.3-0.912-2.88-2.038-3.529L271.968,128.017 c-1.125-0.65-2.95-0.65-4.075,0l-110.127,63.604c-1.125,0.65-2.038,2.23-2.038,3.529v0.812c0,1.299,0.912,2.879,2.038,3.529 l179.015,103.253c1.125,0.65,2.95,0.65,4.075,0l110.127-63.603C452.108,238.492,453.021,236.912,453.021,235.612z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_339_",
    style: {
      opacity: 0.6
    },
    d: "M453.021,235.612V234.8c0-1.3-0.912-2.88-2.038-3.529L271.968,128.017 c-1.125-0.65-2.95-0.65-4.075,0l-110.127,63.604c-1.125,0.65-2.038,2.23-2.038,3.529v0.812c0,1.299,0.912,2.879,2.038,3.529 l179.015,103.253c1.125,0.65,2.95,0.65,4.075,0l110.127-63.603C452.108,238.492,453.021,236.912,453.021,235.612z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3947_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3948_",
    style: {
      fill: "#27DEBF"
    },
    d: "M338.819,297.718v5.521c0.737,0,1.474-0.173,2.039-0.486l110.122-63.606 c1.129-0.659,2.039-2.228,2.039-3.529v-0.816c0-1.145-0.706-2.525-1.663-3.263c0.737,0.628,0.612,1.506-0.376,2.086 l-110.122,63.606C340.293,297.561,339.556,297.718,338.819,297.718z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3946_",
    style: {
      opacity: 0.5
    },
    d: "M338.819,297.718v5.521c0.737,0,1.474-0.173,2.039-0.486l110.122-63.606 c1.129-0.659,2.039-2.228,2.039-3.529v-0.816c0-1.145-0.706-2.525-1.663-3.263c0.737,0.628,0.612,1.506-0.376,2.086 l-110.122,63.606C340.293,297.561,339.556,297.718,338.819,297.718z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3942_",
    style: {
      fill: "#27DEBF"
    },
    d: "M450.983,233.624l-110.127,63.603c-1.125,0.65-2.95,0.65-4.075,0 L157.766,193.974c-1.125-0.65-1.125-1.703,0-2.353l110.127-63.604c1.125-0.65,2.95-0.65,4.075,0l179.015,103.253 C452.109,231.92,452.109,232.974,450.983,233.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_337_",
    style: {
      opacity: 0.4
    },
    d: "M450.983,233.624l-110.127,63.603c-1.125,0.65-2.95,0.65-4.075,0 L157.766,193.974c-1.125-0.65-1.125-1.703,0-2.353l110.127-63.604c1.125-0.65,2.95-0.65,4.075,0l179.015,103.253 C452.109,231.92,452.109,232.974,450.983,233.624z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Keyboard_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_30_",
    style: {
      opacity: 0.15
    },
    d: "M325.29,232.236l-26.092,15.107c-0.807,0.467-2.116,0.468-2.924,0.003 l-77.084-44.444c-0.808-0.466-0.809-1.222-0.002-1.689l26.092-15.107c0.807-0.467,2.116-0.468,2.924-0.003l77.084,44.444 C326.096,231.012,326.097,231.768,325.29,232.236z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Keyboard_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3931_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3936_",
    style: {
      fill: "#263238"
    },
    d: "M220.77,198.534c0-0.306,0.202-0.611,0.605-0.845l24.513-14.15 c0.807-0.466,2.117-0.466,2.924,0.001l74.797,43.255c0.403,0.233,0.605,0.539,0.605,0.844c0,0.305,0,2.266,0,2.57 c0.001,0.306-0.202,0.612-0.607,0.844l-24.5,14.149c-0.808,0.465-2.118,0.464-2.926-0.003l-74.805-43.186 c-0.402-0.232-0.604-0.536-0.605-0.841C220.768,200.866,220.77,198.839,220.77,198.534z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3935_",
    style: {
      fill: "#37474F"
    },
    d: "M299.106,242.566l24.5-14.085c0.808-0.465,0.809-1.22,0.002-1.686 l-74.796-43.255c-0.807-0.467-2.116-0.467-2.924-0.001l-24.513,14.15c-0.807,0.466-0.807,1.222,0,1.688l74.805,43.186 C296.988,243.029,298.298,243.03,299.106,242.566z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3933_",
    style: {
      fill: "#263238"
    },
    d: "M297.738,242.913v2.628c0.495-0.011,0.99-0.124,1.373-0.337l24.492-14.148 c0.405-0.236,0.608-0.54,0.608-0.844v-2.577c0,0.304-0.203,0.608-0.608,0.844l-24.492,14.092 C298.728,242.784,298.233,242.902,297.738,242.913z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3768_",
    style: {
      fill: "#27DEBF"
    },
    d: "M225.309,198.722c0-0.015,0.011-0.027,0.017-0.03l2.425-1.4l3.292,1.9 l-2.44,1.447l-3.288-1.898L225.309,198.722z M229.107,196.53c0-0.016,0.012-0.028,0.017-0.031l2.426-1.401l2.585,1.492 l-2.442,1.448l-2.582-1.491L229.107,196.53z M229.907,201.377c0-0.016,0.012-0.027,0.017-0.031l2.427-1.401l2.583,1.492 l-2.442,1.448l-2.58-1.49L229.907,201.377z M232.905,194.337c0-0.016,0.011-0.029,0.017-0.032l2.425-1.4l4.175,2.411 l-2.44,1.449l-4.173-2.41L232.905,194.337z M232.999,198.776c0-0.016,0.011-0.028,0.017-0.031l2.426-1.401l2.054,1.185 l-2.443,1.449l-2.05-1.184L232.999,198.776z M233.798,203.623c0-0.016,0.012-0.028,0.017-0.031l2.425-1.4l2.585,1.492 l-2.442,1.447l-2.58-1.49L233.798,203.623z M236.357,200.717c0-0.016,0.013-0.029,0.019-0.033l2.425-1.4l2.052,1.186 l-2.441,1.448l-2.05-1.184L236.357,200.717z M236.703,192.145c0-0.017,0.011-0.029,0.017-0.032l2.426-1.4l3.292,1.901 l-2.443,1.448l-3.288-1.899L236.703,192.145z M237.689,205.87c0-0.016,0.011-0.028,0.017-0.031l2.425-1.4l18.678,10.783 l-2.444,1.448l-18.673-10.782L237.689,205.87z M238.388,197.503c0-0.016,0.011-0.029,0.017-0.032l2.425-1.4l2.052,1.186 l-2.441,1.448l-2.05-1.184L238.388,197.503z M239.719,202.656c0-0.017,0.012-0.029,0.017-0.032l2.425-1.4l2.052,1.186 l-2.441,1.447l-2.05-1.184L239.719,202.656z M240.501,189.952c0-0.017,0.011-0.029,0.017-0.032l2.425-1.401l2.052,1.186 l-2.441,1.449l-2.05-1.184L240.501,189.952z M241.301,194.799c0-0.016,0.012-0.028,0.017-0.031l2.425-1.401l2.054,1.186 l-2.443,1.448l-2.05-1.184L241.301,194.799z M241.748,199.443c0-0.016,0.011-0.029,0.017-0.032l2.426-1.4l2.052,1.186 l-2.443,1.449l-2.048-1.184L241.748,199.443z M243.079,204.596c0-0.017,0.012-0.029,0.017-0.033l2.426-1.4l2.052,1.186 l-2.443,1.448l-2.049-1.184L243.079,204.596z M243.862,191.892c0-0.017,0.012-0.029,0.017-0.033l2.425-1.4l2.052,1.185 l-2.441,1.448l-2.05-1.184L243.862,191.892z M244.661,196.739c0-0.016,0.011-0.028,0.017-0.031l2.425-1.401l2.054,1.185 l-2.443,1.448l-2.05-1.184L244.661,196.739z M245.107,201.383c0-0.016,0.013-0.028,0.019-0.032l2.425-1.401l2.052,1.186 l-2.443,1.449l-2.049-1.184L245.107,201.383z M245.11,187.291c0-0.016,0.012-0.029,0.017-0.032l2.426-1.401l2.583,1.493 l-2.443,1.448l-2.579-1.491L245.11,187.291z M246.439,206.536c0-0.016,0.011-0.028,0.017-0.032l2.425-1.4l2.052,1.186 l-2.441,1.448l-2.05-1.184L246.439,206.536z M247.222,193.832c0-0.017,0.012-0.029,0.017-0.033l2.426-1.4l2.052,1.185 l-2.441,1.448l-2.05-1.184L247.222,193.832z M248.021,198.68c0-0.016,0.012-0.029,0.017-0.032l2.425-1.401l2.054,1.186 l-2.443,1.448l-2.05-1.184L248.021,198.68z M248.469,203.323c0-0.016,0.011-0.028,0.017-0.031l2.425-1.401l2.052,1.186 l-2.443,1.448l-2.048-1.184L248.469,203.323z M249.8,208.476c0-0.016,0.012-0.029,0.017-0.032l2.426-1.4l2.052,1.186 l-2.441,1.448l-2.05-1.184L249.8,208.476z M250.462,190.381c0-0.016,0.012-0.028,0.017-0.031l2.427-1.401l2.052,1.186 l-2.443,1.448l-2.05-1.184L250.462,190.381z M250.58,195.773c0-0.016,0.013-0.029,0.019-0.033l2.425-1.4l2.052,1.186 l-2.443,1.449l-2.048-1.184L250.58,195.773z M251.382,200.62c0-0.017,0.012-0.028,0.017-0.032l2.426-1.401l2.054,1.186 l-2.443,1.448l-2.05-1.184L251.382,200.62z M251.827,205.263c0-0.017,0.013-0.029,0.019-0.033l2.425-1.4l2.052,1.186 l-2.442,1.448l-2.049-1.184L251.827,205.263z M253.158,210.417c0-0.016,0.013-0.028,0.019-0.032l2.426-1.401l2.052,1.186 l-2.442,1.448l-2.049-1.184L253.158,210.417z M253.822,192.322c0-0.017,0.011-0.029,0.017-0.033l2.425-1.399l2.054,1.185 l-2.442,1.448l-2.05-1.184L253.822,192.322z M253.94,197.711c0-0.016,0.012-0.027,0.017-0.031l2.427-1.401l2.052,1.186 l-2.443,1.448l-2.048-1.184L253.94,197.711z M254.742,202.56c0-0.016,0.011-0.029,0.017-0.032l2.426-1.4l2.054,1.185 l-2.443,1.448l-2.05-1.184L254.742,202.56z M255.187,207.203c0-0.016,0.011-0.028,0.017-0.031l2.427-1.401l2.052,1.186 l-2.443,1.448l-2.049-1.184L255.187,207.203z M256.52,212.356c0-0.016,0.011-0.028,0.017-0.031l2.425-1.401l2.052,1.186 l-2.441,1.447l-2.051-1.184L256.52,212.356z M257.183,194.261c0-0.016,0.012-0.029,0.017-0.032l2.425-1.399l2.054,1.185 l-2.443,1.448l-2.05-1.184L257.183,194.261z M257.302,199.652c0-0.017,0.012-0.029,0.017-0.033l2.426-1.4l2.052,1.186 l-2.442,1.448l-2.049-1.184L257.302,199.652z M257.674,217.408c0-0.016,0.011-0.029,0.017-0.032l2.425-1.401l2.583,1.492 l-2.443,1.449l-2.58-1.49L257.674,217.408z M258.102,204.5c0-0.016,0.012-0.028,0.017-0.032l2.425-1.401l2.054,1.186 l-2.443,1.448l-2.051-1.184L258.102,204.5z M258.548,209.142c0-0.016,0.011-0.027,0.017-0.031l2.427-1.401l2.052,1.186 l-2.443,1.448l-2.049-1.184L258.548,209.142z M259.88,214.296c0-0.016,0.012-0.029,0.017-0.032l2.425-1.4l2.052,1.186 l-2.443,1.448l-2.048-1.184L259.88,214.296z M260.543,196.201c0-0.016,0.012-0.028,0.017-0.031l2.426-1.401l2.054,1.185 l-2.443,1.448l-2.051-1.184L260.543,196.201z M260.661,201.593c0-0.017,0.013-0.029,0.019-0.033l2.426-1.4l2.052,1.186 l-2.443,1.448l-2.049-1.184L260.661,201.593z M261.462,206.44c0-0.016,0.012-0.029,0.017-0.032l2.425-1.401l2.054,1.186 l-2.443,1.448l-2.05-1.184L261.462,206.44z M261.563,219.655c0-0.016,0.013-0.029,0.019-0.033l2.426-1.4l2.584,1.492 l-2.441,1.449l-2.582-1.491L261.563,219.655z M261.908,211.083c0-0.016,0.013-0.029,0.019-0.033l2.425-1.4l2.052,1.186 l-2.442,1.448l-2.049-1.184L261.908,211.083z M263.239,216.237c0-0.017,0.013-0.029,0.019-0.033l2.426-1.4l2.052,1.186 l-2.441,1.447l-2.05-1.183L263.239,216.237z M264.021,203.532c0-0.016,0.012-0.028,0.017-0.031l2.427-1.401l2.052,1.185 l-2.443,1.449l-2.048-1.184L264.021,203.532z M264.823,208.379c0-0.016,0.011-0.028,0.017-0.031l2.426-1.401l2.052,1.186 l-2.441,1.447l-2.05-1.184L264.823,208.379z M265.268,213.023c0-0.016,0.011-0.028,0.017-0.031l2.427-1.401l2.052,1.186 l-2.443,1.448l-2.049-1.184L265.268,213.023z M265.365,198.985c0-0.016,0.011-0.028,0.017-0.031l2.425-1.401l2.054,1.186 l-2.443,1.448l-2.05-1.184L265.365,198.985z M265.455,221.901c0-0.017,0.011-0.029,0.017-0.032l2.426-1.4l2.585,1.492 l-2.443,1.448l-2.582-1.49L265.455,221.901z M266.599,218.175c0-0.016,0.012-0.027,0.017-0.03l2.427-1.401l2.052,1.186 l-2.443,1.448l-2.048-1.184L266.599,218.175z M267.382,205.472c0-0.018,0.015-0.03,0.019-0.033l2.424-1.399l2.054,1.185 l-2.443,1.449l-2.049-1.184L267.382,205.472z M268.183,210.319c0-0.016,0.011-0.028,0.017-0.031l2.425-1.401l2.054,1.186 l-2.443,1.448l-2.05-1.184L268.183,210.319z M268.628,214.962c0-0.016,0.011-0.028,0.017-0.031l2.427-1.401l2.052,1.186 l-2.443,1.448l-2.049-1.184L268.628,214.962z M268.725,200.925c0-0.016,0.012-0.028,0.017-0.031l2.425-1.401l2.055,1.186 l-2.443,1.448l-2.05-1.184L268.725,200.925z M269.346,224.147c0-0.016,0.011-0.029,0.017-0.032l2.425-1.401l3.292,1.901 l-2.443,1.448l-3.288-1.898L269.346,224.147z M269.959,220.117c0-0.016,0.013-0.028,0.019-0.032l2.425-1.401l6.475,3.738 l-2.443,1.448l-6.471-3.737L269.959,220.117z M270.742,207.411c0-0.016,0.012-0.028,0.017-0.032l2.427-1.4l2.052,1.186 l-2.443,1.448l-2.049-1.184L270.742,207.411z M271.543,212.26c0-0.017,0.012-0.029,0.017-0.032l2.426-1.401l2.054,1.186 l-2.443,1.448l-2.05-1.184L271.543,212.26z M271.989,216.902c0-0.015,0.012-0.027,0.017-0.031l2.427-1.401l2.052,1.186 l-2.443,1.448l-2.049-1.184L271.989,216.902z M272.086,202.866c0-0.017,0.012-0.029,0.017-0.032l2.426-1.401l2.054,1.186 l-2.442,1.448l-2.051-1.184L272.086,202.866z M274.102,209.351c0-0.016,0.012-0.028,0.017-0.032l2.427-1.4l2.052,1.186 l-2.443,1.448l-2.048-1.184L274.102,209.351z M274.65,227.21c0-0.015,0.011-0.027,0.017-0.03l2.427-1.402l2.052,1.186 l-2.443,1.448l-2.049-1.184L274.65,227.21z M274.904,214.2c0-0.017,0.011-0.029,0.017-0.032l2.426-1.401l2.052,1.186 l-2.441,1.447l-2.05-1.184L274.904,214.2z M275.349,218.842c0-0.015,0.011-0.027,0.017-0.03l2.427-1.402l1.875,1.083 c0.132,0.076,0.352,0.121,0.592,0.121c0.251,0,0.478-0.046,0.621-0.129l3.185-1.84l2.406,1.391l-6.237,3.641l-4.881-2.818 L275.349,218.842z M275.446,204.805c0-0.016,0.011-0.028,0.017-0.031l2.425-1.401l2.054,1.186l-2.443,1.448l-2.05-1.184 L275.446,204.805z M277.462,211.292c0-0.016,0.011-0.028,0.017-0.031l2.425-1.401l2.054,1.186l-2.443,1.448l-2.049-1.184 L277.462,211.292z M278.012,229.15c0-0.016,0.011-0.029,0.017-0.032l2.425-1.401l2.052,1.186l-2.443,1.448l-2.049-1.184 L278.012,229.15z M278.264,216.14c0-0.016,0.011-0.029,0.017-0.032l2.426-1.401l2.052,1.186l-2.443,1.448l-2.048-1.184 L278.264,216.14z M280.268,207.59c0-0.016,0.012-0.029,0.017-0.032l2.426-1.401l2.054,1.186l-2.443,1.448l-2.05-1.184 L280.268,207.59z M280.822,213.231c0-0.016,0.011-0.028,0.017-0.032l2.425-1.399l2.054,1.186l-2.443,1.448l-2.049-1.184 L280.822,213.231z M281.371,231.09c0-0.016,0.012-0.029,0.019-0.033l2.426-1.4l2.052,1.186l-2.443,1.448l-2.049-1.184 L281.371,231.09z M281.808,226.957c0-0.016,0.011-0.029,0.017-0.033l2.427-1.4l2.052,1.186l-2.443,1.448l-2.051-1.184 L281.808,226.957z M283.629,209.53c0-0.016,0.011-0.029,0.017-0.032l2.426-1.401l2.052,1.186l-2.441,1.448l-2.051-1.184 L283.629,209.53z M284.182,215.171c0-0.016,0.011-0.028,0.017-0.032l2.426-1.399l3.646,2.104l-2.443,1.448l-3.64-2.103 L284.182,215.171z M285.439,233.438c0-0.016,0.011-0.028,0.017-0.031l2.426-1.401l5.414,3.126l-2.443,1.448l-5.411-3.124 L285.439,233.438z M286.044,220.632c0-0.017,0.012-0.029,0.017-0.032l2.425-1.4l2.054,1.186l-2.44,1.448l-2.052-1.184 L286.044,220.632z M286.989,211.47c0-0.017,0.011-0.029,0.017-0.032l2.425-1.401l2.052,1.186l-2.441,1.448l-2.05-1.184 L286.989,211.47z M289.237,231.246c0-0.016,0.011-0.028,0.017-0.032l2.425-1.4l2.054,1.186l-2.441,1.448l-2.052-1.184 L289.237,231.246z M289.405,222.572c0-0.017,0.011-0.029,0.017-0.032l2.425-1.399l2.054,1.185l-2.443,1.449l-2.05-1.184 L289.405,222.572z M289.842,218.439c0-0.016,0.012-0.029,0.017-0.032l2.426-1.401l2.054,1.186l-2.442,1.448l-2.051-1.183 L289.842,218.439z M290.349,213.41c0-0.016,0.012-0.029,0.017-0.032l2.425-1.401l2.052,1.186l-2.441,1.448l-2.05-1.184 L290.349,213.41z M292.159,237.318c0-0.016,0.011-0.029,0.017-0.032l2.425-1.399l2.055,1.185l-2.443,1.448l-2.05-1.184 L292.159,237.318z M292.597,233.186c0-0.017,0.012-0.029,0.017-0.032l2.426-1.4l2.054,1.185l-2.443,1.448l-2.05-1.184 L292.597,233.186z M292.765,224.512c0-0.017,0.011-0.028,0.017-0.032l2.425-1.4l2.054,1.186l-2.443,1.448l-2.051-1.184 L292.765,224.512z M293.035,229.053c0-0.017,0.011-0.028,0.017-0.032l2.426-1.401l2.052,1.186l-2.441,1.448l-2.05-1.184 L293.035,229.053z M293.203,220.379c0-0.016,0.011-0.028,0.017-0.032l2.425-1.4l2.054,1.186l-2.443,1.448l-2.05-1.184 L293.203,220.379z M294.452,215.779c0-0.016,0.012-0.029,0.017-0.032l2.425-1.401l2.054,1.186l-2.443,1.448l-2.05-1.184 L294.452,215.779z M295.52,239.258c0-0.017,0.011-0.029,0.017-0.033l6.224-3.592l2.054,1.186l-6.239,3.642l-2.052-1.185 L295.52,239.258z M295.958,235.126c0-0.016,0.011-0.029,0.017-0.032l2.425-1.4l2.054,1.186l-2.443,1.449l-2.051-1.184 L295.958,235.126z M296.396,230.993c0-0.016,0.011-0.029,0.017-0.032l2.425-1.401l2.052,1.186l-2.441,1.448l-2.05-1.184 L296.396,230.993z M296.563,222.32c0-0.017,0.012-0.029,0.017-0.032l2.425-1.4l2.054,1.185l-2.443,1.448l-2.05-1.184 L296.563,222.32z M296.832,226.861c0-0.016,0.011-0.027,0.017-0.03l2.427-1.403l2.052,1.186l-2.442,1.448l-2.049-1.184 L296.832,226.861z M297.812,217.719c0-0.016,0.012-0.029,0.017-0.032l2.426-1.401l2.054,1.186l-2.443,1.448l-2.05-1.184 L297.812,217.719z M299.756,232.933c0-0.016,0.012-0.029,0.017-0.032l2.425-1.401l2.052,1.186l-2.441,1.449l-2.05-1.184 L299.756,232.933z M300.192,228.801c0-0.016,0.012-0.027,0.017-0.031l2.427-1.403l2.052,1.186l-2.443,1.448l-2.048-1.184 L300.192,228.801z M300.629,224.667c0-0.016,0.012-0.028,0.017-0.031l2.426-1.401l2.054,1.186l-2.443,1.448l-2.049-1.184 L300.629,224.667z M301.172,219.658c0-0.016,0.011-0.029,0.017-0.032l2.426-1.401l2.054,1.186l-2.443,1.448l-2.051-1.184 L301.172,219.658z M303.116,234.873c0-0.016,0.012-0.029,0.017-0.032l6.224-3.593l2.052,1.186l-6.237,3.642l-2.052-1.185 L303.116,234.873z M303.552,230.74c0-0.015,0.011-0.027,0.017-0.03l2.427-1.403l2.052,1.186l-2.443,1.448l-2.049-1.184 L303.552,230.74z M303.99,226.607c0-0.015,0.011-0.027,0.017-0.03l2.425-1.402l2.054,1.185l-2.443,1.448l-2.048-1.184 L303.99,226.607z M306.215,221.444c0-0.017,0.011-0.028,0.017-0.032l1.03-0.608l2.054,1.185l-1.055,0.651l-2.043-1.179 L306.215,221.444z M307.35,228.548c0-0.016,0.012-0.028,0.017-0.031l2.426-1.401l2.054,1.186l-2.443,1.448l-2.048-1.184 L307.35,228.548z M309.576,223.384c0-0.016,0.012-0.029,0.017-0.032l1.03-0.607l2.054,1.186l-1.055,0.65l-2.043-1.178 L309.576,223.384z M310.71,230.487c0-0.016,0.012-0.028,0.017-0.031l2.426-1.401l2.054,1.185l-2.443,1.448l-2.049-1.184 L310.71,230.487z M312.936,225.324c0-0.016,0.011-0.028,0.017-0.032l1.03-0.607l2.054,1.185l-1.055,0.651l-2.043-1.179 L312.936,225.324z M316.294,227.264c0-0.016,0.013-0.029,0.019-0.033l1.03-0.608l2.054,1.186l-1.055,0.651l-2.043-1.179 L316.294,227.264z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow_29_",
    style: {
      opacity: 0.15
    },
    points: "385.581,235.168 408.534,221.916 293.77,155.657 270.816,168.908  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Monitor_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3761_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3766_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3767_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M320.594,213.596l-16.387-9.475c-1.689-0.975-2.534-2.253-2.534-3.531 c0-1.278-0.007-2.279-0.007-2.279l15.419-8.752c0.901-0.52,1.631-1.785,1.631-2.826V166.53l28.621,16.539l0.001,20.203 c0,1.04-0.73,2.305-1.631,2.825l-12.88,7.499C329.449,215.546,323.972,215.546,320.594,213.596z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3765_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M340.467,206.849v2.27l5.246-3.023c0.895-0.518,1.629-1.78,1.629-2.825V183.07 l-5.453-3.146c-0.113,1.385-0.235,2.816-0.348,4.21l3.823,2.213v15.784c0,1.045-0.725,2.307-1.629,2.825L340.467,206.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3764_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M345.365,202.135c0,1.04-0.73,2.305-1.631,2.825l-10.904,6.357 c-3.378,1.951-8.856,1.951-12.235,0.001l-16.395-9.474c-3.379-1.95-3.379-5.111-0.001-7.062l10.912-6.362 c0.901-0.52,1.631-1.785,1.631-2.825l0-15.786l28.622,16.539V202.135z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3763_",
    style: {
      fill: "#EBEBEB"
    },
    d: "M311.789,190.341v-0.002l3.322-1.918c0.901-0.52,1.631-1.785,1.631-2.825 v-15.786l28.622,16.539v15.787c0,1.04-0.73,2.305-1.631,2.825l-3.265,1.885L311.789,190.341z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3762_",
    style: {
      fill: "#EBEBEB"
    },
    d: "M301.669,198.312c0,0,0,0.998,0,2.279c0,1.281,0.848,2.552,2.533,3.532 l16.389,9.469c1.62,0.942,3.72,1.413,5.839,1.45v-2.27c-2.119-0.028-4.219-0.518-5.839-1.45l-16.389-9.479 C302.517,200.874,301.669,199.593,301.669,198.312z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3760_",
    style: {
      fill: "#455A64"
    },
    d: "M391.32,223.93c-1.056,0.61-2.826,0.577-3.952-0.073 c-14.071-8.124-96.619-55.782-110.688-63.905c-1.126-0.65-2.038-2.231-2.038-3.531V59.537c0-1.3,0.856-2.849,1.913-3.459 c1.056-0.61,2.826-0.577,3.952,0.073l110.687,63.905c1.126,0.65,2.039,2.231,2.039,3.532l0.001,96.884 C393.233,221.772,392.377,223.32,391.32,223.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3758_",
    style: {
      fill: "#37474F"
    },
    d: "M387.368,223.855L276.68,159.95c-1.126-0.65-2.039-2.231-2.039-3.532V59.534 c0-1.3,0.913-1.827,2.039-1.177l110.686,63.905c1.126,0.65,2.039,2.231,2.039,3.532l0.001,96.884 C389.407,223.978,388.494,224.505,387.368,223.855z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3757_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M387.668,224.259c1.13,0.499,2.693,0.48,3.654-0.075 c1.055-0.612,1.912-2.157,1.912-3.466v-10.896l-3.824,2.213v10.896C389.41,224.118,388.657,224.654,387.668,224.259z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3756_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M389.407,212.032l0,10.896c0,1.3-0.913,1.827-2.039,1.177L276.68,160.201 c-1.126-0.65-2.039-2.231-2.039-3.532v-10.896L389.407,212.032z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3755_",
    style: {
      fill: "#27DEBF"
    },
    d: "M385.582,203.743l-0.001-76.68c0-0.78-0.548-1.729-1.223-2.119L279.692,64.515 c-0.676-0.39-1.224-0.074-1.224,0.706l-0.004,76.682c0,0.78,0.548,1.729,1.223,2.119l104.67,60.427 C385.035,204.84,385.582,204.524,385.582,203.743z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3754_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M385.582,203.743l-0.001-76.68c0-0.78-0.548-1.729-1.223-2.119 L279.692,64.515c-0.676-0.39-1.224-0.074-1.224,0.706l-0.004,76.682c0,0.78,0.548,1.729,1.223,2.119l104.67,60.427 C385.035,204.84,385.582,204.524,385.582,203.743z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3658_",
    style: {
      fill: "#455A64"
    },
    d: "M332.026,183.07c1.057,0.61,1.913,2.094,1.913,3.314 c0,1.22-0.857,1.714-1.913,1.104c-1.057-0.61-1.913-2.094-1.913-3.314C330.112,182.954,330.969,182.46,332.026,183.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3657_",
    style: {
      fill: "#263238"
    },
    d: "M388.807,123.776c0.367,0.64,0.593,1.366,0.603,2.015v86.243l3.824-2.213 v-86.234c0-0.65-0.235-1.375-0.603-2.015L388.807,123.776z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Window_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_3_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M292.752,39.532c0.006-0.064,0.013-0.122,0.032-0.179c-0.006-0.013,0-0.026,0.006-0.038 c0.006-0.064,0.026-0.122,0.045-0.173c0.026-0.09,0.064-0.173,0.115-0.25c0.013-0.038,0.038-0.07,0.064-0.102 c0.019-0.026,0.032-0.051,0.057-0.071c0.039-0.051,0.077-0.09,0.128-0.128c0,0,0.006-0.006,0.013-0.013 c0.051-0.038,0.109-0.07,0.167-0.096c0.352-0.167,0.807-0.122,1.313,0.167l129.174,74.546c1.076,0.621,1.953,2.139,1.953,3.382 v93.492c0,0.006-0.002,0.011-0.002,0.016v0.427c0,0.529-0.296,0.953-0.703,1.173c-0.028,0.019-0.056,0.037-0.083,0.055 c-0.032,0.019-0.064,0.038-0.103,0.058c-0.051,0.026-0.109,0.045-0.167,0.058c-0.083,0.019-0.166,0.032-0.25,0.032 c-0.198,0.006-0.423-0.058-0.647-0.186l-0.051-0.029c-0.001-0.001-0.003-0.001-0.004-0.002l-1.862-1.075l-127.257-73.472 c-1.076-0.621-1.953-2.133-1.953-3.382V39.775C292.739,39.692,292.746,39.609,292.752,39.532z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3010_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3044_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M293.38,38.481c0.352-0.167,0.807-0.122,1.313,0.167l129.174,74.546 c1.076,0.621,1.953,2.139,1.953,3.382v6.379l2.492-1.46v-6.334c0-1.243-0.871-2.754-1.947-3.375L297.184,37.239 c-0.557-0.327-1.057-0.333-1.415-0.115C295.417,37.335,293.796,38.264,293.38,38.481z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3036_",
    style: {
      fill: "#27DEBF"
    },
    d: "M292.744,39.762c0.008-1.232,0.877-1.731,1.95-1.112l129.175,74.545 c1.078,0.622,1.951,2.135,1.951,3.38l-0.002,6.382L292.744,46.166V39.762z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3027_",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.694,38.65l129.172,74.545c0.534,0.313,1.025,0.841,1.375,1.448l2.479-1.436 c-0.35-0.601-0.83-1.124-1.357-1.425L297.186,37.237c-0.558-0.325-1.056-0.33-1.418-0.116c-0.35,0.215-1.97,1.135-2.381,1.356 C293.731,38.312,294.191,38.361,294.694,38.65z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3011_",
    style: {
      opacity: 0.15
    },
    d: "M428.315,121.503l-0.001-6.344c0-0.632-0.232-1.332-0.594-1.951l-2.485,1.43 c0.362,0.614,0.583,1.307,0.583,1.939v6.381L428.315,121.503z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3000_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3009_",
    style: {
      fill: "#455A64"
    },
    d: "M421.419,114.543c0.609,0.352,1.102,1.396,1.102,2.334 s-0.494,1.412-1.102,1.061c-0.609-0.352-1.103-1.396-1.103-2.334C420.316,114.667,420.81,114.192,421.419,114.543z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3002_",
    style: {
      fill: "#455A64"
    },
    d: "M417.449,112.247c0.609,0.352,1.103,1.396,1.103,2.334 s-0.494,1.412-1.103,1.061c-0.609-0.352-1.102-1.396-1.102-2.334C416.347,112.371,416.841,111.896,417.449,112.247z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3001_",
    style: {
      fill: "#455A64"
    },
    d: "M413.48,109.951c0.609,0.352,1.102,1.396,1.102,2.334 c0,0.937-0.493,1.412-1.102,1.061c-0.609-0.352-1.103-1.396-1.103-2.334S412.871,109.6,413.48,109.951z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#263238"
    },
    d: "M425.119,211.692l0.101-0.057l2.057-1.19c0.557-0.316,0.93-0.88,1.019-1.513 c0.013-0.095,0.019-0.19,0.019-0.285v-87.152l-2.494,1.462v87.551c0,0.487-0.247,0.886-0.608,1.108 c-0.019,0.019-0.044,0.031-0.063,0.044c-0.006,0.006-0.006,0.013-0.013,0.013L425.119,211.692z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Code"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2979_",
    style: {
      fill: "#27DEBF"
    },
    d: "M332.31,79.438l27.234,15.694c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.311,0.572-0.693,0.351L332.31,80.94c-0.383-0.221-0.693-0.737-0.693-1.151 C331.617,79.374,331.927,79.217,332.31,79.438z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2977_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M342.717,109.48l10.323,5.937c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-10.323-5.937c-0.383-0.221-0.693-0.737-0.693-1.152 C342.024,109.416,342.334,109.259,342.717,109.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2971_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M342.717,115.488l10.323,5.937c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-10.323-5.937c-0.383-0.221-0.693-0.737-0.693-1.151 C342.024,115.424,342.334,115.267,342.717,115.488z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2967_",
    style: {
      fill: "#27DEBF"
    },
    d: "M362.232,96.683l54.524,31.401c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-54.524-31.401c-0.383-0.221-0.693-0.737-0.693-1.151 C361.539,96.619,361.849,96.462,362.232,96.683z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2926_",
    style: {
      fill: "#27DEBF"
    },
    d: "M342.942,151.611l16.603,9.606c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.311,0.572-0.693,0.351l-16.603-9.606c-0.383-0.221-0.693-0.736-0.693-1.151 C342.248,151.547,342.559,151.39,342.942,151.611z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2925_",
    style: {
      fill: "#27DEBF"
    },
    d: "M362.232,162.769l54.524,31.441c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-54.524-31.441c-0.383-0.221-0.693-0.736-0.693-1.151 C361.539,162.705,361.849,162.548,362.232,162.769z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2876_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2905_",
    style: {
      fill: "#27DEBF"
    },
    d: "M332.31,85.46l13.718,7.882c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.311,0.572-0.693,0.351l-13.718-7.882c-0.383-0.221-0.693-0.737-0.693-1.151 C331.617,85.396,331.927,85.239,332.31,85.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2890_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M332.31,85.46l13.718,7.882c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.311,0.572-0.693,0.351l-13.718-7.882c-0.383-0.221-0.693-0.737-0.693-1.151 C331.617,85.396,331.927,85.239,332.31,85.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2873_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2875_",
    style: {
      fill: "#27DEBF"
    },
    d: "M332.31,91.457l6.418,3.701c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.736-0.693-1.151 C331.617,91.393,331.927,91.236,332.31,91.457z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2874_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M332.31,91.457l6.418,3.701c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.736-0.693-1.151 C331.617,91.393,331.927,91.236,332.31,91.457z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2867_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2869_",
    style: {
      fill: "#27DEBF"
    },
    d: "M332.31,103.473l6.418,3.701c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.151 C331.617,103.409,331.927,103.252,332.31,103.473z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2868_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M332.31,103.473l6.418,3.701 c0.383,0.221,0.693,0.737,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.151 C331.617,103.409,331.927,103.252,332.31,103.473z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2864_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2866_",
    style: {
      fill: "#27DEBF"
    },
    d: "M332.31,109.481l6.418,3.701c0.383,0.221,0.693,0.737,0.693,1.151 s-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.151S331.927,109.26,332.31,109.481z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2865_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M332.31,109.481l6.418,3.701 c0.383,0.221,0.693,0.737,0.693,1.151s-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.151 S331.927,109.26,332.31,109.481z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2855_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2863_",
    style: {
      fill: "#27DEBF"
    },
    d: "M348.715,94.894l8.227,4.765c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.311,0.572-0.693,0.351l-8.227-4.765c-0.383-0.221-0.693-0.737-0.693-1.151 C348.022,94.83,348.332,94.673,348.715,94.894z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2862_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M348.715,94.894l8.227,4.765 c0.383,0.221,0.693,0.737,0.693,1.151c0,0.415-0.311,0.572-0.693,0.351l-8.227-4.765c-0.383-0.221-0.693-0.737-0.693-1.151 C348.022,94.83,348.332,94.673,348.715,94.894z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2853_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2854_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M361.437,138.328l55.319,31.85c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-55.319-31.85c-0.383-0.221-0.693-0.736-0.693-1.152 C360.744,138.264,361.054,138.107,361.437,138.328z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2851_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2852_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M408.529,159.395l8.227,4.765c0.383,0.221,0.693,0.737,0.693,1.151 s-0.31,0.572-0.693,0.351l-8.227-4.765c-0.383-0.221-0.693-0.737-0.693-1.151 C407.836,159.331,408.146,159.174,408.529,159.395z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2849_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2850_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M350.522,125.994l55.319,31.85c0.383,0.221,0.693,0.737,0.693,1.151 s-0.31,0.572-0.693,0.351l-55.319-31.85c-0.383-0.221-0.693-0.736-0.693-1.151 C349.829,125.93,350.139,125.773,350.522,125.994z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2846_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2848_",
    style: {
      fill: "#27DEBF"
    },
    d: "M342.717,97.466l13.718,7.882c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-13.718-7.882c-0.383-0.221-0.693-0.737-0.693-1.151 C342.023,97.402,342.334,97.244,342.717,97.466z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2847_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M342.717,97.466l13.718,7.882 c0.383,0.221,0.693,0.737,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-13.718-7.882c-0.383-0.221-0.693-0.737-0.693-1.151 C342.023,97.402,342.334,97.244,342.717,97.466z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2823_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2845_",
    style: {
      fill: "#27DEBF"
    },
    d: "M359.122,106.899l57.225,33.105c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-57.225-33.105c-0.383-0.221-0.693-0.737-0.693-1.151 C358.429,106.835,358.739,106.678,359.122,106.899z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2839_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M359.122,106.899l57.225,33.105 c0.383,0.221,0.693,0.736,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-57.225-33.105c-0.383-0.221-0.693-0.737-0.693-1.151 C358.429,106.835,358.739,106.678,359.122,106.899z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2978_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M342.717,133.636l74.039,42.697c0.383,0.221,0.693,0.737,0.693,1.151 s-0.31,0.572-0.693,0.351l-74.039-42.697c-0.383-0.221-0.693-0.737-0.693-1.151 C342.024,133.572,342.334,133.415,342.717,133.636z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2870_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2872_",
    style: {
      fill: "#27DEBF"
    },
    d: "M332.31,127.63l6.418,3.701c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.152 C331.617,127.566,331.927,127.409,332.31,127.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2871_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M332.31,127.63l6.418,3.701c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.152 C331.617,127.566,331.927,127.409,332.31,127.63z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2986_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M342.717,139.642l74.039,42.697c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-74.039-42.696c-0.383-0.221-0.693-0.737-0.693-1.151 C342.024,139.578,342.334,139.421,342.717,139.642z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2981_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2984_",
    style: {
      fill: "#27DEBF"
    },
    d: "M332.31,133.636l6.418,3.701c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.151 C331.617,133.572,331.927,133.415,332.31,133.636z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2983_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M332.31,133.636l6.418,3.701 c0.383,0.221,0.693,0.736,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.151 C331.617,133.572,331.927,133.415,332.31,133.636z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2994_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M342.717,145.648l74.039,42.697c0.383,0.221,0.693,0.737,0.693,1.151 s-0.31,0.572-0.693,0.351l-74.039-42.697c-0.383-0.221-0.693-0.737-0.693-1.151 C342.024,145.584,342.334,145.427,342.717,145.648z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2991_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2993_",
    style: {
      fill: "#27DEBF"
    },
    d: "M332.31,139.642l6.418,3.701c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.152 C331.617,139.578,331.927,139.421,332.31,139.642z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2992_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M332.31,139.642l6.418,3.701 c0.383,0.221,0.693,0.737,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-6.418-3.701c-0.383-0.221-0.693-0.737-0.693-1.152 C331.617,139.578,331.927,139.421,332.31,139.642z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,73.414l3.772,2.178c0.378,0.218,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,73.373,321.927,73.196,322.306,73.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,79.479l3.772,2.178c0.378,0.218,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,79.438,321.927,79.261,322.306,79.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,85.544l3.772,2.178c0.378,0.218,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,85.503,321.927,85.325,322.306,85.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,91.608l3.772,2.178c0.378,0.219,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.219-0.685-0.75-0.685-1.187l0-1.387 C321.62,91.567,321.927,91.39,322.306,91.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,97.673l3.772,2.178c0.378,0.219,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,97.632,321.927,97.455,322.306,97.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,103.738l3.772,2.178c0.378,0.218,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,103.697,321.927,103.52,322.306,103.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,109.803l3.772,2.178c0.378,0.219,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,109.761,321.927,109.584,322.306,109.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,115.868l3.772,2.178c0.378,0.218,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,115.826,321.927,115.649,322.306,115.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,121.932l3.772,2.178c0.378,0.218,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,121.891,321.927,121.714,322.306,121.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,127.997l3.772,2.178c0.378,0.218,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,127.956,321.927,127.779,322.306,127.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,134.062l3.772,2.178c0.378,0.219,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,134.021,321.927,133.843,322.306,134.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.306,140.127l3.772,2.178c0.378,0.218,0.685,0.75,0.685,1.187v1.387 c0,0.437-0.307,0.614-0.685,0.396l-3.772-2.178c-0.378-0.218-0.685-0.75-0.685-1.187l0-1.387 C321.62,140.085,321.927,139.908,322.306,140.127z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M297.28,53.714l20.399,11.778c0.757,0.437,1.37,1.5,1.37,2.373l0,23.555 c0,0.874-0.613,1.228-1.37,0.791L297.28,80.433c-0.757-0.437-1.37-1.5-1.37-2.374V54.505 C295.91,53.631,296.523,53.277,297.28,53.714z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2822_",
    style: {
      fill: "#27DEBF"
    },
    d: "M299.174,77.063l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C298.48,76.999,298.791,76.842,299.174,77.063z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2821_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M299.174,77.063l1.878,1.086 c0.383,0.221,0.693,0.736,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C298.48,76.999,298.791,76.842,299.174,77.063z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2820_",
    style: {
      fill: "#27DEBF"
    },
    d: "M299.174,57.773l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C298.48,57.709,298.791,57.552,299.174,57.773z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_529_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M299.174,57.773l1.878,1.086 c0.383,0.221,0.693,0.737,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C298.48,57.709,298.791,57.552,299.174,57.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,63.146l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,63.082,301.43,62.925,301.813,63.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,63.146l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,63.082,301.43,62.925,301.813,63.146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,66.994l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,66.93,301.43,66.773,301.813,66.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,66.994l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,66.93,301.43,66.773,301.813,66.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M299.174,69.344l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C298.48,69.28,298.791,69.123,299.174,69.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M299.174,69.344l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C298.48,69.28,298.791,69.123,299.174,69.344z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,74.721l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,74.657,301.43,74.5,301.813,74.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,74.721l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,74.657,301.43,74.5,301.813,74.721z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_354_",
    style: {
      fill: "#27DEBF"
    },
    d: "M304.316,60.744l11.469,6.622c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.736-0.693-1.151 C303.623,60.68,303.933,60.523,304.316,60.744z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_353_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M304.316,60.744l11.469,6.622 c0.383,0.221,0.693,0.737,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.736-0.693-1.151 C303.623,60.68,303.933,60.523,304.316,60.744z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_352_",
    style: {
      fill: "#27DEBF"
    },
    d: "M304.316,80.034l11.469,6.622c0.383,0.221,0.693,0.736,0.693,1.151 s-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.736-0.693-1.151C303.623,79.969,303.933,79.812,304.316,80.034 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_343_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M304.316,80.034l11.469,6.622 c0.383,0.221,0.693,0.736,0.693,1.151s-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.736-0.693-1.151 C303.623,79.969,303.933,79.812,304.316,80.034z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,66.117l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151 C306.262,66.052,306.573,65.895,306.956,66.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,66.117l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151 C306.262,66.052,306.573,65.895,306.956,66.117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,69.974l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.737-0.693-1.151 C306.262,69.91,306.573,69.753,306.956,69.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,69.974l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.737-0.693-1.151 C306.262,69.91,306.573,69.753,306.956,69.974z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M304.316,72.318l11.469,6.622c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151 C303.623,72.254,303.933,72.097,304.316,72.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M304.316,72.318l11.469,6.622c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151 C303.623,72.254,303.933,72.097,304.316,72.318z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,77.692l8.829,5.106c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.106c-0.383-0.221-0.693-0.737-0.693-1.151 C306.262,77.628,306.573,77.471,306.956,77.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,77.692l8.829,5.106c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.106c-0.383-0.221-0.693-0.737-0.693-1.151 C306.262,77.628,306.573,77.471,306.956,77.692z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M297.28,84.865l20.399,11.778c0.757,0.437,1.37,1.5,1.37,2.373l0,46.545 c0,0.874-0.613,1.228-1.37,0.791l-20.399-11.778c-0.757-0.437-1.37-1.5-1.37-2.374V85.656 C295.91,84.782,296.523,84.428,297.28,84.865z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_342_",
    style: {
      fill: "#27DEBF"
    },
    d: "M299.174,88.925l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C298.48,88.861,298.791,88.704,299.174,88.925z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_341_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M299.174,88.925l1.878,1.086 c0.383,0.221,0.693,0.737,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C298.48,88.861,298.791,88.704,299.174,88.925z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,94.298l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,94.234,301.43,94.077,301.813,94.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,94.298l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,94.234,301.43,94.077,301.813,94.298z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,98.146l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C301.12,98.082,301.43,97.925,301.813,98.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,98.146l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C301.12,98.082,301.43,97.925,301.813,98.146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M299.174,100.496l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C298.48,100.432,298.791,100.274,299.174,100.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M299.174,100.496l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C298.48,100.432,298.791,100.274,299.174,100.496z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_340_",
    style: {
      fill: "#27DEBF"
    },
    d: "M304.316,91.895l11.469,6.622c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151 C303.623,91.831,303.933,91.674,304.316,91.895z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_321_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M304.316,91.895l11.469,6.622 c0.383,0.221,0.693,0.736,0.693,1.151c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151 C303.623,91.831,303.933,91.674,304.316,91.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,97.268l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151 C306.262,97.204,306.573,97.047,306.956,97.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,97.268l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151 C306.262,97.204,306.573,97.047,306.956,97.268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,101.126l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.737-0.693-1.151 C306.262,101.062,306.573,100.905,306.956,101.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,101.126l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.737-0.693-1.151 C306.262,101.062,306.573,100.905,306.956,101.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M304.316,103.469l11.469,6.622c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151 C303.623,103.405,303.933,103.248,304.316,103.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M304.316,103.469l11.469,6.622c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151 C303.623,103.405,303.933,103.248,304.316,103.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,105.895l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,105.831,301.43,105.674,301.813,105.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,105.895l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C301.12,105.831,301.43,105.674,301.813,105.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,109.743l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C301.12,109.679,301.43,109.522,301.813,109.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,109.743l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C301.12,109.679,301.43,109.522,301.813,109.743z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,108.865l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151 C306.262,108.801,306.573,108.644,306.956,108.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,108.865l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151 C306.262,108.801,306.573,108.644,306.956,108.865z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,112.723l8.829,5.107c0.383,0.221,0.693,0.736,0.693,1.151s-0.31,0.572-0.693,0.351 l-8.829-5.107c-0.383-0.221-0.693-0.737-0.693-1.151C306.262,112.659,306.573,112.502,306.956,112.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,112.723l8.829,5.107c0.383,0.221,0.693,0.736,0.693,1.151 s-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.737-0.693-1.151 C306.262,112.659,306.573,112.502,306.956,112.723z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M299.174,119.831l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151s-0.31,0.572-0.693,0.351 l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151C298.48,119.768,298.791,119.61,299.174,119.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M299.174,119.831l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 s-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151C298.48,119.768,298.791,119.61,299.174,119.831 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M304.316,122.805l11.469,6.622c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151S303.933,122.584,304.316,122.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M304.316,122.805l11.469,6.622c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151S303.933,122.584,304.316,122.805z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,125.231l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.152 C301.12,125.167,301.43,125.009,301.813,125.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,125.231l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.152 C301.12,125.167,301.43,125.009,301.813,125.231z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,129.079l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C301.12,129.015,301.43,128.857,301.813,129.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,129.079l1.878,1.086c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C301.12,129.015,301.43,128.857,301.813,129.079z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,128.201l8.829,5.107c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151 C306.262,128.137,306.573,127.979,306.956,128.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,128.201l8.829,5.107c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151 C306.262,128.137,306.573,127.979,306.956,128.201z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,132.059l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151s-0.31,0.572-0.693,0.351 l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151C306.262,131.995,306.573,131.837,306.956,132.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,132.059l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 s-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.736-0.693-1.151 C306.262,131.995,306.573,131.837,306.956,132.059z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M301.813,113.57l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C301.12,113.506,301.43,113.349,301.813,113.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M301.813,113.57l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151 C301.12,113.506,301.43,113.349,301.813,113.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M299.174,115.92l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151s-0.31,0.572-0.693,0.351 l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151C298.48,115.856,298.791,115.699,299.174,115.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M299.174,115.92l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 s-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.737-0.693-1.151C298.48,115.856,298.791,115.699,299.174,115.92 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.956,116.55l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.737-0.693-1.151 C306.262,116.486,306.573,116.329,306.956,116.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M306.956,116.55l8.829,5.107c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-8.829-5.107c-0.383-0.221-0.693-0.737-0.693-1.151 C306.262,116.486,306.573,116.329,306.956,116.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M304.316,118.894l11.469,6.622c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.736-0.693-1.151 C303.623,118.829,303.933,118.672,304.316,118.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M304.316,118.894l11.469,6.622c0.383,0.221,0.693,0.736,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.736-0.693-1.151 C303.623,118.829,303.933,118.672,304.316,118.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M299.174,131.482l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C298.48,131.418,298.791,131.261,299.174,131.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M299.174,131.482l1.878,1.086c0.383,0.221,0.693,0.737,0.693,1.151 c0,0.415-0.31,0.572-0.693,0.351l-1.878-1.086c-0.383-0.221-0.693-0.736-0.693-1.151 C298.48,131.418,298.791,131.261,299.174,131.482z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M304.316,134.455l11.469,6.622c0.383,0.221,0.693,0.737,0.693,1.151s-0.31,0.572-0.693,0.351 l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151C303.623,134.391,303.933,134.234,304.316,134.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M304.316,134.455l11.469,6.622c0.383,0.221,0.693,0.737,0.693,1.151 s-0.31,0.572-0.693,0.351l-11.469-6.622c-0.383-0.221-0.693-0.737-0.693-1.151 C303.623,134.391,303.933,134.234,304.316,134.455z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Window_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3556_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3571_",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M410.784,150.294v76.378c0,1.015,0.713,2.244,1.588,2.749l43.879,25.317 c0.182,0.104,0.364,0.156,0.526,0.151c0.068,0,0.135-0.01,0.203-0.026c0.047-0.01,0.094-0.026,0.136-0.047 c0.031-0.016,0.057-0.031,0.083-0.047c0.031-0.021,0.062-0.042,0.094-0.063c0.031-0.026,0.063-0.047,0.088-0.078 c0.125-0.115,0.219-0.255,0.292-0.417c0.104-0.234,0.167-0.51,0.167-0.802v-75.993c0-1.01-0.713-2.244-1.588-2.749 l-43.879-25.29c-0.411-0.234-0.781-0.271-1.067-0.135c-0.047,0.021-0.094,0.047-0.135,0.078c-0.005,0.005-0.01,0.01-0.01,0.01 c-0.042,0.031-0.073,0.063-0.104,0.104c-0.021,0.016-0.031,0.036-0.047,0.057c-0.021,0.026-0.042,0.052-0.052,0.083 c-0.042,0.063-0.073,0.13-0.094,0.203c-0.016,0.042-0.031,0.088-0.036,0.141c-0.005,0.01-0.01,0.021-0.005,0.031 c-0.016,0.047-0.021,0.094-0.026,0.146C410.789,150.159,410.784,150.226,410.784,150.294z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3563_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3568_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M411.305,149.242c0.286-0.135,0.656-0.099,1.067,0.135l43.879,25.29 c0.875,0.505,1.588,1.739,1.588,2.749v5.185l2.529-1.462v-5.149c0-1.01-0.708-2.239-1.583-2.743l-43.884-25.291 c-0.453-0.266-0.859-0.271-1.151-0.094C413.464,148.036,411.643,149.065,411.305,149.242z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3567_",
    style: {
      fill: "#27DEBF"
    },
    d: "M410.788,150.283c0.006-1.002,0.713-1.407,1.585-0.903l43.879,25.29 c0.876,0.506,1.586,1.736,1.586,2.747l-0.002,5.188l-47.048-27.116V150.283z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3566_",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M412.373,149.379l43.876,25.29c0.434,0.254,0.833,0.683,1.117,1.177l2.519-1.442 c-0.284-0.489-0.674-0.914-1.103-1.158l-43.88-25.29c-0.454-0.264-0.858-0.268-1.152-0.094 c-0.284,0.175-2.105,1.197-2.439,1.377C411.59,149.105,411.964,149.145,412.373,149.379z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3564_",
    style: {
      opacity: 0.15
    },
    d: "M460.37,181.147l-0.001-5.156c0-0.514-0.188-1.082-0.483-1.586l-2.524,1.437 c0.294,0.499,0.474,1.063,0.474,1.576v5.187L460.37,181.147z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3559_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3562_",
    style: {
      fill: "#455A64"
    },
    d: "M455.531,176.803c0.495,0.286,0.896,1.135,0.896,1.897 c0,0.762-0.401,1.148-0.896,0.862c-0.495-0.286-0.896-1.135-0.896-1.897C454.635,176.904,455.036,176.517,455.531,176.803z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3561_",
    style: {
      fill: "#455A64"
    },
    d: "M452.304,174.937c0.495,0.286,0.896,1.135,0.896,1.897 c0,0.762-0.401,1.148-0.896,0.862c-0.495-0.286-0.896-1.135-0.896-1.897C451.408,175.037,451.81,174.651,452.304,174.937z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3560_",
    style: {
      fill: "#455A64"
    },
    d: "M449.078,173.071c0.495,0.286,0.896,1.135,0.896,1.897 c0,0.762-0.401,1.148-0.896,0.862c-0.495-0.286-0.896-1.135-0.896-1.897C448.182,173.171,448.583,172.785,449.078,173.071z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3558_",
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M457.255,254.742c0.057-0.036,0.125-0.073,0.198-0.115c0.146-0.089,0.313-0.182,0.489-0.276 l0.005-0.005c0.088-0.052,0.177-0.104,0.265-0.151c0.005-0.005,0.016-0.01,0.021-0.01c0.146-0.083,0.286-0.167,0.417-0.24 c0.135-0.078,0.759-0.42,0.852-0.472c0.094-0.057,0.167-0.094,0.198-0.109c0.099-0.052,0.193-0.125,0.271-0.219 c0.083-0.089,0.156-0.198,0.214-0.323c0.115-0.239,0.182-0.531,0.182-0.838v-70.844l-2.529,1.462v70.807 c-0.016,0.312-0.073,0.578-0.167,0.802c-0.073,0.161-0.167,0.302-0.292,0.417c-0.021,0.031-0.052,0.057-0.088,0.078 C457.281,254.722,457.271,254.732,457.255,254.742z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2916_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3493_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3552_",
    style: {
      fill: "#27DEBF"
    },
    d: "M414.431,164.251c0-0.095,0.027-0.163,0.081-0.203l1.14-1.043 c0.019-0.012,0.036-0.016,0.052-0.01c0.015,0.006,0.025,0.01,0.029,0.012c0.034,0.02,0.064,0.056,0.09,0.11 c0.025,0.053,0.038,0.106,0.038,0.159v0.793c0,0.101-0.008,0.174-0.023,0.218c-0.015,0.045-0.042,0.085-0.081,0.123 l-0.602,0.553l0.602,1.247c0.039,0.082,0.066,0.154,0.081,0.216c0.016,0.063,0.023,0.144,0.023,0.245v0.793 c0,0.053-0.013,0.092-0.038,0.117c-0.025,0.024-0.055,0.026-0.09,0.006c-0.004-0.002-0.014-0.009-0.029-0.021 c-0.016-0.012-0.033-0.035-0.052-0.07l-1.14-2.36c-0.054-0.102-0.081-0.201-0.081-0.296V164.251z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3548_",
    style: {
      fill: "#27DEBF"
    },
    d: "M418.602,163.15c0.019-0.054,0.048-0.099,0.086-0.133 c0.039-0.034,0.095-0.03,0.168,0.012l0.428,0.247c0.035,0.02,0.065,0.057,0.09,0.11c0.025,0.053,0.037,0.106,0.037,0.159 c0,0.024-0.004,0.049-0.011,0.074l-1.955,6.077c-0.015,0.051-0.043,0.094-0.081,0.131c-0.039,0.037-0.096,0.034-0.173-0.011 l-0.411-0.237c-0.035-0.02-0.065-0.056-0.09-0.109c-0.026-0.053-0.038-0.107-0.038-0.16c0-0.024,0.004-0.048,0.011-0.073 L418.602,163.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3541_",
    style: {
      fill: "#27DEBF"
    },
    d: "M421.628,168.994c0,0.095-0.027,0.162-0.081,0.202l-1.14,1.043 c-0.019,0.013-0.037,0.016-0.052,0.01c-0.015-0.006-0.025-0.01-0.029-0.012c-0.035-0.02-0.065-0.057-0.09-0.11 c-0.025-0.053-0.037-0.106-0.037-0.16v-0.793c0-0.101,0.008-0.174,0.023-0.219c0.015-0.045,0.043-0.085,0.081-0.123 l0.602-0.552l-0.602-1.247c-0.038-0.081-0.066-0.154-0.081-0.216c-0.015-0.062-0.023-0.144-0.023-0.244v-0.793 c0-0.053,0.012-0.092,0.037-0.117c0.025-0.024,0.055-0.026,0.09-0.006c0.003,0.002,0.013,0.009,0.029,0.021 c0.016,0.012,0.033,0.035,0.052,0.07l1.14,2.36c0.054,0.102,0.081,0.201,0.081,0.296V168.994z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3522_",
    style: {
      fill: "#27DEBF"
    },
    d: "M424.798,172.107c0.042,0.024,0.079,0.069,0.11,0.135 c0.031,0.065,0.046,0.131,0.046,0.196v0.873c0,0.066-0.016,0.112-0.046,0.143c-0.031,0.029-0.068,0.032-0.11,0.007l-0.538-0.31 c-0.043-0.025-0.079-0.07-0.11-0.134c-0.031-0.066-0.046-0.131-0.046-0.196v-0.873c0-0.065,0.015-0.113,0.046-0.143 c0.03-0.03,0.067-0.033,0.11-0.008L424.798,172.107z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3499_",
    style: {
      fill: "#27DEBF"
    },
    d: "M426.598,173.147c0.042,0.024,0.079,0.069,0.11,0.134 c0.031,0.066,0.046,0.131,0.046,0.196v0.873c0,0.066-0.015,0.113-0.046,0.143c-0.031,0.029-0.068,0.032-0.11,0.008 l-0.538-0.311c-0.043-0.025-0.079-0.069-0.11-0.134c-0.031-0.066-0.046-0.13-0.046-0.196v-0.873 c0-0.065,0.015-0.113,0.046-0.143c0.031-0.029,0.067-0.033,0.11-0.008L426.598,173.147z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3497_",
    style: {
      fill: "#27DEBF"
    },
    d: "M428.397,174.185c0.042,0.024,0.079,0.069,0.11,0.135 c0.03,0.065,0.046,0.131,0.046,0.196v0.873c0,0.066-0.016,0.112-0.046,0.143c-0.031,0.029-0.068,0.032-0.11,0.007l-0.538-0.311 c-0.043-0.025-0.079-0.07-0.11-0.134c-0.031-0.066-0.046-0.13-0.046-0.196v-0.873c0-0.065,0.015-0.113,0.046-0.143 c0.031-0.03,0.067-0.033,0.11-0.008L428.397,174.185z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3489_",
    style: {
      fill: "#27DEBF"
    },
    d: "M414.911,171.171l26.364,15.221c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-26.364-15.221c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,171.119,414.599,170.991,414.911,171.171z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3488_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M423.37,190.706l26.364,15.221c0.311,0.18,0.564,0.599,0.564,0.936 s-0.252,0.465-0.564,0.285l-26.364-15.221c-0.311-0.18-0.564-0.599-0.564-0.936C422.806,190.654,423.058,190.526,423.37,190.706 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3480_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M423.37,200.473l12.619,7.291c0.311,0.18,0.564,0.599,0.564,0.936 s-0.252,0.465-0.564,0.285l-12.618-7.29c-0.311-0.18-0.564-0.599-0.564-0.936C422.806,200.421,423.058,200.293,423.37,200.473z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3458_",
    style: {
      fill: "#27DEBF"
    },
    d: "M443.459,187.653l10.504,6.042c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-10.504-6.042c-0.311-0.18-0.564-0.599-0.564-0.936S443.148,187.473,443.459,187.653z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3455_",
    style: {
      fill: "#27DEBF"
    },
    d: "M414.911,224.887l26.364,15.221c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-26.364-15.221c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,224.835,414.599,224.707,414.911,224.887z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3452_",
    style: {
      fill: "#27DEBF"
    },
    d: "M443.459,241.369l10.504,6.042c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-10.504-6.042c-0.311-0.18-0.564-0.599-0.564-0.936 C442.896,241.317,443.148,241.189,443.459,241.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3448_",
    style: {
      fill: "#27DEBF"
    },
    d: "M443.459,226.744l10.504,6.042c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-10.504-6.042c-0.311-0.18-0.564-0.599-0.564-0.936 C442.896,226.692,443.148,226.564,443.459,226.744z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3288_",
    style: {
      fill: "#27DEBF"
    },
    d: "M443.459,231.627l10.504,6.042c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-10.504-6.042c-0.311-0.18-0.564-0.599-0.564-0.936 C442.896,231.575,443.148,231.447,443.459,231.627z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3285_",
    style: {
      fill: "#27DEBF"
    },
    d: "M434.503,221.559l5.901,3.408c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-5.901-3.407c-0.311-0.18-0.564-0.599-0.564-0.936 C433.939,221.506,434.192,221.379,434.503,221.559z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3242_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3244_",
    style: {
      fill: "#27DEBF"
    },
    d: "M414.911,176.066l15.378,8.872c0.311,0.18,0.564,0.599,0.564,0.936 s-0.252,0.465-0.564,0.285l-15.378-8.872c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,176.014,414.599,175.886,414.911,176.066z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3243_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M414.911,176.066l15.378,8.872 c0.311,0.18,0.564,0.599,0.564,0.936s-0.252,0.465-0.564,0.285l-15.378-8.872c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,176.014,414.599,175.886,414.911,176.066z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3239_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3241_",
    style: {
      fill: "#27DEBF"
    },
    d: "M414.911,180.94l5.217,3.008c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-5.217-3.008c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,180.888,414.599,180.76,414.911,180.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3240_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M414.911,180.94l5.217,3.008c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-5.217-3.008c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,180.888,414.599,180.76,414.911,180.94z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3236_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3238_",
    style: {
      fill: "#27DEBF"
    },
    d: "M414.911,185.824l5.217,3.008c0.311,0.18,0.564,0.599,0.564,0.936 s-0.252,0.465-0.564,0.285l-5.217-3.008c-0.311-0.18-0.564-0.599-0.564-0.936C414.347,185.772,414.599,185.644,414.911,185.824 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3237_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M414.911,185.824l5.217,3.008c0.311,0.18,0.564,0.599,0.564,0.936 s-0.252,0.465-0.564,0.285l-5.217-3.008c-0.311-0.18-0.564-0.599-0.564-0.936C414.347,185.772,414.599,185.644,414.911,185.824 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3234_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3235_",
    style: {
      fill: "#27DEBF"
    },
    d: "M414.911,190.707l5.217,3.008c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-5.217-3.008c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,190.655,414.599,190.527,414.911,190.707z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3233_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M414.911,190.706l5.217,3.008c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-5.217-3.008c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,190.654,414.599,190.526,414.911,190.706z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3232_",
    style: {
      opacity: 0.6,
      fill: "#27DEBF"
    },
    d: "M423.369,195.589l15.378,8.872c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-15.378-8.872c-0.311-0.18-0.564-0.599-0.564-0.936 C422.806,195.537,423.058,195.41,423.369,195.589z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3228_",
    style: {
      opacity: 0.6,
      fill: "#27DEBF"
    },
    d: "M440.931,205.722l6.687,3.873c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-6.687-3.873c-0.311-0.18-0.564-0.599-0.564-0.936 C440.368,205.67,440.62,205.542,440.931,205.722z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3205_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M423.369,195.589l15.378,8.872c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-15.378-8.872c-0.311-0.18-0.564-0.599-0.564-0.936 C422.806,195.537,423.058,195.41,423.369,195.589z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3204_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M440.931,205.722l6.687,3.873c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-6.687-3.873c-0.311-0.18-0.564-0.599-0.564-0.936 C440.368,205.67,440.62,205.542,440.931,205.722z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3201_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3203_",
    style: {
      fill: "#27DEBF"
    },
    d: "M414.911,195.59l5.217,3.008c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-5.217-3.008c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,195.538,414.599,195.411,414.911,195.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3202_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M414.911,195.59l5.217,3.008c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-5.217-3.008c-0.311-0.18-0.564-0.599-0.564-0.936 C414.347,195.538,414.599,195.411,414.911,195.59z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3198_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3200_",
    style: {
      fill: "#27DEBF"
    },
    d: "M432.473,186.198l6.687,3.873c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-6.687-3.873c-0.311-0.18-0.564-0.599-0.564-0.936 C431.909,186.146,432.162,186.019,432.473,186.198z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3199_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M432.473,186.198l6.687,3.873c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-6.687-3.873c-0.311-0.18-0.564-0.599-0.564-0.936 C431.909,186.146,432.162,186.019,432.473,186.198z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3196_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3197_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M429.714,209.012l15.378,8.872c0.311,0.18,0.563,0.599,0.563,0.936 s-0.252,0.465-0.563,0.285l-15.378-8.872c-0.311-0.18-0.564-0.599-0.564-0.936C429.15,208.96,429.403,208.833,429.714,209.012z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3194_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3195_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M438.586,219.038l15.378,8.872c0.311,0.18,0.564,0.599,0.564,0.936 s-0.252,0.465-0.564,0.285l-15.378-8.872c-0.311-0.18-0.564-0.599-0.564-0.936 C438.022,218.986,438.274,218.858,438.586,219.038z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3094_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3193_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M447.276,219.145l6.687,3.873c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-6.687-3.873c-0.311-0.18-0.564-0.599-0.564-0.936 C446.712,219.093,446.965,218.965,447.276,219.145z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2998_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2999_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M447.276,238.487l6.687,3.873c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-6.687-3.873c-0.311-0.18-0.564-0.599-0.564-0.936 C446.712,238.435,446.965,238.308,447.276,238.487z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2995_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2997_",
    style: {
      fill: "#27DEBF"
    },
    d: "M423.369,185.824l15.378,8.872c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-15.378-8.872c-0.311-0.18-0.564-0.599-0.564-0.936 C422.806,185.772,423.058,185.644,423.369,185.824z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2996_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M423.369,185.824l15.378,8.872 c0.311,0.18,0.564,0.599,0.564,0.936c0,0.337-0.252,0.465-0.564,0.285l-15.378-8.872c-0.311-0.18-0.564-0.599-0.564-0.936 C422.806,185.772,423.058,185.644,423.369,185.824z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2918_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2922_",
    style: {
      fill: "#27DEBF"
    },
    d: "M440.931,195.956l6.687,3.873c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-6.687-3.873c-0.311-0.18-0.564-0.599-0.564-0.936 C440.368,195.904,440.62,195.777,440.931,195.956z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2919_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M440.931,195.956l6.687,3.873c0.311,0.18,0.564,0.599,0.564,0.936 c0,0.337-0.252,0.465-0.564,0.285l-6.687-3.873c-0.311-0.18-0.564-0.599-0.564-0.936 C440.368,195.904,440.62,195.777,440.931,195.956z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mouse_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M336.115,251.905l9.425,5.441c2.971,1.715,7.627,1.469,10.4-0.549l15.545-11.351 c2.774-2.018,2.616-5.048-0.352-6.768l-4.726-2.738c-2.968-1.72-7.859-1.868-10.926-0.331l-19.193,10.406 C333.223,247.554,333.145,250.19,336.115,251.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M371.744,240.515l-10.757,8.409l-7.937,6.21c-0.77,0.36-1.652,0.559-2.534,0.609 c-1.341,0.075-2.708-0.186-3.764-0.795l-8.434-4.869c0,0-0.012,0-0.012-0.012c-0.016-0.009-0.032-0.018-0.048-0.028 c-2.959-1.722-3.657-5.721-1.704-8.533c0.081-0.117,0.164-0.231,0.249-0.345c1.602-2.161,3.987-3.726,6.782-4.298l4.273-0.857 c6.919-1.404,12.595-2.087,13.253-1.64l10.57,6.124C371.707,240.49,371.732,240.502,371.744,240.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M365.731,245.218l0.604-0.473l-9.485-5.476l8.3-2.569c-0.286-0.165-0.567-0.327-0.839-0.485 l-8.3,2.569l-5.656-3.266c-0.352,0.065-0.711,0.133-1.072,0.203L365.731,245.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M353.982,254.625c0.012-0.012,0.037-0.025,0.05-0.037c0-0.013,0.013-0.013,0.013-0.013 l7.552-5.453l10.198-7.366v-1.155c0-0.037-0.013-0.062-0.05-0.087c-0.012-0.012-0.037-0.025-0.062-0.025 c-0.758-0.261-5.18,1.068-10.521,3.192l-3.54,1.404c-1.105,0.435-2.124,1.043-3.018,1.789c-2.546,2.099-4.087,5.266-4.087,8.682 v0.186c0.882-0.05,1.764-0.249,2.534-0.609L353.982,254.625z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pot_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3653_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3654_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3655_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3717_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3718_",
    style: {
      fill: "#27DEBF"
    },
    d: "M372.699,405.512c-10.378-10.708-16.474-54.288-6.352-62.782h51.503 c10.12,8.491,4.03,52.056-6.341,62.771c-0.089,0.1-0.191,0.196-0.284,0.295c-0.119,0.119-0.237,0.239-0.357,0.353 c-0.293,0.287-0.604,0.568-0.938,0.844c-0.082,0.069-0.165,0.13-0.248,0.197c-0.254,0.201-0.505,0.404-0.783,0.598 c-0.442,0.317-0.889,0.613-1.341,0.867c-8.537,4.984-22.377,4.984-30.913,0l-0.001,0l-0.001,0 c-0.456-0.256-0.905-0.554-1.351-0.873c-0.258-0.181-0.491-0.37-0.729-0.557c-0.102-0.082-0.205-0.158-0.307-0.243 c-0.322-0.266-0.622-0.537-0.905-0.814c-0.139-0.132-0.276-0.27-0.412-0.408C372.86,405.677,372.773,405.596,372.699,405.512z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3668_",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3669_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M372.699,405.512c-10.378-10.708-16.474-54.288-6.352-62.782h51.503 c10.12,8.491,4.03,52.056-6.341,62.771c-0.089,0.1-0.191,0.196-0.284,0.295c-0.119,0.119-0.237,0.239-0.357,0.353 c-0.293,0.287-0.604,0.568-0.938,0.844c-0.082,0.069-0.165,0.13-0.248,0.197c-0.254,0.201-0.505,0.404-0.783,0.598 c-0.442,0.317-0.889,0.613-1.341,0.867c-8.537,4.984-22.377,4.984-30.913,0l-0.001,0l-0.001,0 c-0.456-0.256-0.905-0.554-1.351-0.873c-0.258-0.181-0.491-0.37-0.729-0.557c-0.102-0.082-0.205-0.158-0.307-0.243 c-0.322-0.266-0.622-0.537-0.905-0.814c-0.139-0.132-0.276-0.27-0.412-0.408C372.86,405.677,372.773,405.596,372.699,405.512z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3666_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3667_",
    style: {
      fill: "#27DEBF"
    },
    d: "M413.378,339.31c11.751,6.861,11.751,17.985,0,24.846 c-11.752,6.861-30.804,6.861-42.555,0c-11.751-6.861-11.751-17.985,0.001-24.845 C382.574,332.449,401.626,332.449,413.378,339.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3664_",
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3665_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M413.378,339.31c11.751,6.861,11.751,17.985,0,24.846 c-11.752,6.861-30.804,6.861-42.555,0c-11.751-6.861-11.751-17.985,0.001-24.845 C382.574,332.449,401.626,332.449,413.378,339.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3662_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3663_",
    style: {
      fill: "#27DEBF"
    },
    d: "M407.726,342.609c8.63,5.039,8.63,13.208,0,18.246 c-8.63,5.038-22.622,5.039-31.252,0c-8.63-5.038-8.63-13.207,0-18.246C385.104,337.571,399.096,337.571,407.726,342.609z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3660_",
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3661_",
    d: "M407.726,342.609c8.63,5.039,8.63,13.208,0,18.246c-8.63,5.038-22.622,5.039-31.252,0 c-8.63-5.038-8.63-13.207,0-18.246C385.104,337.571,399.096,337.571,407.726,342.609z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3656_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3659_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M376.474,351.269c8.63-5.039,22.621-5.039,31.251,0 c2.397,1.4,4.103,3.045,5.169,4.793c-1.066,1.748-2.772,3.393-5.169,4.793c-8.63,5.038-22.622,5.038-31.251,0 c-2.397-1.4-4.104-3.045-5.169-4.793C372.37,354.314,374.077,352.669,376.474,351.269z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Plants_20_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3595_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3645_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3652_",
    style: {
      fill: "#27DEBF"
    },
    d: "M387.881,329.277c-0.576-1.171-1.062-2.388-1.314-3.758 c-0.577-3.137,0.205-6.734,2.744-8.665c1.01-0.769,2.325-1.338,2.755-2.533c0.237-0.658,0.147-1.385,0.026-2.074 c-0.472-2.678-1.376-5.436-0.631-8.052c0.689-2.42,2.722-4.275,4.995-5.353c2.273-1.079,4.795-1.492,7.278-1.901 c1.324-0.218,2.677-0.449,3.848-1.104c1.439-0.805,1.886-2.227,2.783-3.475c0.987-1.375,2.272-2.648,3.53-3.772 c2.622-2.344,5.908-4.272,9.539-4.111c7.575,0.335,7.361,6.853,5.174,11.795c-2.187,4.942-2.762,6.55,1.97,11.698 c4.732,5.148,4.743,11.493-0.903,15.048c-5.646,3.555-9.321,4.022-7.086,10.863c1.996,6.107,3.232,11.322-2.413,17.85 c-3.648,4.219-8.636,7.23-14.877,6.974c-1.769-0.073-5.656-0.887-7.298-1.702c-1.718-0.854-0.56-2.189-1.141-3.884 c-1.247-3.642-2.494-7.283-3.741-10.924c-0.965-2.818-1.7-5.945-2.975-8.615C389.431,332.082,388.588,330.714,387.881,329.277z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3643_",
    style: {
      opacity: 0.25
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3644_",
    d: "M387.881,329.277c-0.576-1.171-1.062-2.388-1.314-3.758c-0.577-3.137,0.205-6.734,2.744-8.665 c1.01-0.769,2.325-1.338,2.755-2.533c0.237-0.658,0.147-1.385,0.026-2.074c-0.472-2.678-1.376-5.436-0.631-8.052 c0.689-2.42,2.722-4.275,4.995-5.353c2.273-1.079,4.795-1.492,7.278-1.901c1.324-0.218,2.677-0.449,3.848-1.104 c1.439-0.805,1.886-2.227,2.783-3.475c0.987-1.375,2.272-2.648,3.53-3.772c2.622-2.344,5.908-4.272,9.539-4.111 c7.575,0.335,7.361,6.853,5.174,11.795c-2.187,4.942-2.762,6.55,1.97,11.698c4.732,5.148,4.743,11.493-0.903,15.048 c-5.646,3.555-9.321,4.022-7.086,10.863c1.996,6.107,3.232,11.322-2.413,17.85c-3.648,4.219-8.636,7.23-14.877,6.974 c-1.769-0.073-5.656-0.887-7.298-1.702c-1.718-0.854-0.56-2.189-1.141-3.884c-1.247-3.642-2.494-7.283-3.741-10.924 c-0.965-2.818-1.7-5.945-2.975-8.615C389.431,332.082,388.588,330.714,387.881,329.277z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3641_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3642_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M398.18,356.974c0.22-0.077,0.377-0.289,0.375-0.537 c-0.32-37.417,20.303-59.757,20.511-59.978c0.212-0.225,0.203-0.582-0.02-0.797c-0.222-0.215-0.575-0.209-0.788,0.018 c-0.212,0.224-21.142,22.871-20.817,60.765c0.002,0.312,0.254,0.562,0.562,0.56 C398.064,357.004,398.124,356.993,398.18,356.974z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3598_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3640_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M404.182,322.169c0.039-0.014,0.077-0.031,0.113-0.054 c6.71-4.223,18.686-7.373,18.805-7.407c0.301-0.079,0.477-0.384,0.4-0.686c-0.077-0.302-0.382-0.483-0.68-0.405 c-0.498,0.128-12.261,3.227-19.115,7.54c-0.262,0.165-0.341,0.512-0.178,0.776 C403.668,322.161,403.942,322.253,404.182,322.169z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3596_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3597_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M406.255,317.039c0.01-0.003,0.02-0.007,0.029-0.012 c0.285-0.117,0.422-0.446,0.304-0.734c-2.349-5.801-6.034-10.226-6.19-10.412c-0.199-0.237-0.553-0.269-0.786-0.066 c-0.235,0.201-0.263,0.557-0.064,0.795c0.037,0.044,3.728,4.479,6.008,10.107C405.67,316.997,405.978,317.136,406.255,317.039z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3098_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3594_",
    style: {
      fill: "#27DEBF"
    },
    d: "M392.922,361.027c0,0-7.002,2.65-16.428,0.608 c-9.426-2.042-15.192-10.843-15.192-10.843s10.195-4.085,16.141-4.481c0,0-9.225-1.573-17.857,0.383 c0,0-5.456-2.032-4.423-11.246c0,0,5.135-3.785,16.957-2.302c0,0-5.924-4.228-16.308-5.476 c-0.817,0.008,0.289-11.995,1.279-17.345c0.99-5.35,2.955-4.524,7.201-4.062c4.246,0.462,16.806,3.32,18.4,6.401 c1.594,3.081,0.045,10.935,0.045,10.935s3.452-4.296,3.466-10.279c0,0,4.727,1.728,7.254,3.96 c2.527,2.232,3.791,4.035,4.521,5.66c-0.59,4.212-2.572,10.638-5.351,14.228c0,0,6.261-4.042,7.693-11.49 c0,0,5.007,6.395,4.958,14.653C405.221,349.746,401.034,356.736,392.922,361.027z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3719_",
    style: {
      opacity: 0.1
    },
    d: "M392.922,361.027c0,0-7.002,2.65-16.428,0.608 c-9.426-2.042-15.192-10.843-15.192-10.843s10.195-4.085,16.141-4.481c0,0-9.225-1.573-17.857,0.383 c0,0-5.456-2.032-4.423-11.246c0,0,5.135-3.785,16.957-2.302c0,0-5.924-4.228-16.308-5.476 c-0.817,0.008,0.289-11.995,1.279-17.345c0.99-5.35,2.955-4.524,7.201-4.062c4.246,0.462,16.806,3.32,18.4,6.401 c1.594,3.081,0.045,10.935,0.045,10.935s3.452-4.296,3.466-10.279c0,0,4.727,1.728,7.254,3.96 c2.527,2.232,3.791,4.035,4.521,5.66c-0.59,4.212-2.572,10.638-5.351,14.228c0,0,6.261-4.042,7.693-11.49 c0,0,5.007,6.395,4.958,14.653C405.221,349.746,401.034,356.736,392.922,361.027z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3578_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3579_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M394.168,360.19c-0.185-0.072-0.324-0.247-0.341-0.461 c-1.426-17.856-21.404-45.75-30.235-51.35c-0.25-0.159-0.326-0.493-0.169-0.747c0.157-0.254,0.49-0.326,0.739-0.171 c8.976,5.693,29.285,34.04,30.732,52.181c0.024,0.298-0.196,0.56-0.49,0.583C394.32,360.231,394.241,360.218,394.168,360.19z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_179_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_183_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_191_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_192_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M213.491,349.026c-0.036-0.2-3.21-11.793-3.21-11.793s1.045,1.067,7.749-0.702 c3.41-0.9,7.29-3.059,7.29-3.059l1.914,8.475c1.785,3.263,7.704,1.76,14.188,1.022c1.09-0.124,2.21-0.307,3.331-0.5 l0.068-0.008c3.501-0.192,7.016,1.911,3.376,4.896c-3.64,2.986-9.644,4.117-15.179,5.116 C226.36,353.677,214.684,355.632,213.491,349.026z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_184_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_190_",
    style: {
      fill: "#263238"
    },
    d: "M260.039,347.999c0,0,0.702,1.342,0.484,3.562 c-0.127,1.292-3.32,5.673-8.961,8.355c-5.64,2.681-12.62,2.862-15.887,3.802c-3.266,0.94-6.259,2.816-10.108,3.753 c-3.967,0.966-7.656,1.434-11.514-1.106c-0.71-1.096-1.498-3.628-1.27-3.874C213.398,361.828,260.039,347.999,260.039,347.999z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_189_",
    style: {
      fill: "#27DEBF"
    },
    d: "M228.252,343.076c2.483,1.717,7.62,0.525,13.171-0.107 c5.234-0.596,11.127-2.435,14.685-1.202c3.557,1.234,6.532,5.422,1.724,10.791c-1.391,1.553-4.335,4.286-6.687,5.128 c-5.977,2.14-11.34,2.313-15.185,3.262c-5.002,1.235-7.736,3.45-12.364,3.987c-5.988,0.695-9.776-0.844-10.812-2.443 c-1.035-1.599-1.997-14.49,0.57-14.223c0,0,1.08,4.172,10.861,0.12C228.486,346.619,228.418,344.015,228.252,343.076z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_188_",
    style: {
      opacity: 0.4
    },
    d: "M228.252,343.076c2.483,1.717,7.62,0.525,13.171-0.107 c5.234-0.596,11.127-2.435,14.685-1.202c3.557,1.234,6.532,5.422,1.724,10.791c-1.391,1.553-4.335,4.286-6.687,5.128 c-5.977,2.14-11.34,2.313-15.185,3.262c-5.002,1.235-7.736,3.45-12.364,3.987c-5.988,0.695-9.776-0.844-10.812-2.443 c-1.035-1.599-1.997-14.49,0.57-14.223c0,0,1.08,4.172,10.861,0.12C228.486,346.619,228.418,344.015,228.252,343.076z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_187_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M244.851,349.994c0,0-0.562-5.445-4.585-6.886c0,0-1.296-0.595-2.217,0.292 c0,0,3.734,0.542,4.957,6.928c0,0,0.192,0.422,1.005,0.275C244.287,350.552,244.89,350.444,244.851,349.994z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_186_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M234.619,343.823c0,0-0.005-0.18,0.945-0.358 c0.684-0.128,1.103,0.121,1.103,0.121s3.001,1.299,3.562,6.991c0,0-0.024,0.686-0.924,0.875 c-0.9,0.189-1.073-0.557-1.073-0.557S237.614,344.907,234.619,343.823z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_185_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M231.399,343.941c0,0,0.168-0.343,0.874-0.339 c0.891,0.005,1.096,0.349,1.096,0.349s2.137,2.19,2.161,6.945c0,0,0.089,0.806-1.032,0.888c-1.12,0.082-0.96-0.828-0.96-0.828 S233.152,344.897,231.399,343.941z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_180_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_181_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_182_",
    style: {
      fill: "#37474F"
    },
    d: "M209.35,270.196c4.902,14.731,17.902,65.458,17.902,65.458 s-8.46,7.601-17.639,4.138l-21.867-63.167L209.35,270.196z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_166_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_169_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_177_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_178_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M247.139,365.402c-1.001-1.487-4.76-11.804-4.76-11.804 s3.925,2.242,10.671,0.639c3.431-0.816,6.637-4.541,6.637-4.541l2.881,9.918c1.704,3.305,7.208,2.212,13.709,1.633 c1.093-0.098,2.217-0.252,3.343-0.418l0.068-0.006c3.505-0.106,6.967,2.082,3.254,4.978c-3.712,2.896-9.742,3.879-15.3,4.742 C260.956,371.582,250.888,370.969,247.139,365.402z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_170_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_176_",
    style: {
      fill: "#263238"
    },
    d: "M297.56,365.091c0,0,0.719,1.46,0.427,3.837 c-0.17,1.384-3.714,6.003-9.84,8.733c-6.126,2.73-13.624,2.74-17.156,3.663c-3.532,0.923-6.794,2.859-10.951,3.763 c-4.284,0.932-8.257,1.338-12.332-1.491c-0.733-1.196-1.513-3.934-1.261-4.193C247.123,378.707,297.56,365.091,297.56,365.091z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    style: {
      fill: "#27DEBF"
    },
    d: "M263.628,358.872c0.401,0.273,0.807,0.545,1.228,0.762 c0.444,0.227,0.873,0.217,1.365,0.276c1.089,0.131,2.18,0.137,3.275,0.083c2.746-0.136,5.473-0.55,8.21-0.794 c5.634-0.502,12.01-2.321,15.797-0.903c3.787,1.418,7.244,5.976,1.941,11.614c-1.534,1.63-4.691,4.38-7.107,5.391 c-6.29,2.631-12.816,2.139-16.969,3.056c-5.403,1.194-8.396,3.499-13.378,3.954c-6.447,0.588-10.473-1.164-11.543-2.908 c-0.597-0.973,0.067-6.027-0.741-9.953c-0.696-3.38-0.513-5.683,0.702-5.526c0.191,0.436,0.642,0.828,0.941,1.194 c0.39,0.477,0.883,0.85,1.43,1.131c0.759,0.388,1.592,0.605,2.419,0.814c1.472,0.372,2.977,0.733,4.49,0.617 c0.432-0.033,0.883-0.115,1.22-0.388c0.444-0.36,0.59-0.965,0.709-1.525c0.106-0.497,0.212-0.994,0.317-1.491 c0.058-0.27,0.118-0.548,0.272-0.778c0.183-0.273,0.478-0.448,0.766-0.608c0.908-0.507,1.883-1.003,2.456-1.872 c0.448-0.68,0.594-1.51,0.72-2.314c0.022-0.14,0.051-0.293,0.162-0.38c0.184-0.146,0.451-0.022,0.65,0.104 C263.182,358.568,263.405,358.72,263.628,358.872z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    style: {
      opacity: 0.4
    },
    d: "M263.628,358.872c0.401,0.273,0.807,0.545,1.228,0.762 c0.444,0.227,0.873,0.217,1.365,0.276c1.089,0.131,2.18,0.137,3.275,0.083c2.746-0.136,5.473-0.55,8.21-0.794 c5.634-0.502,12.01-2.321,15.797-0.903c3.787,1.418,7.244,5.976,1.941,11.614c-1.534,1.63-4.691,4.38-7.107,5.391 c-6.29,2.631-12.816,2.139-16.969,3.056c-5.403,1.194-8.396,3.499-13.378,3.954c-6.447,0.588-10.473-1.164-11.543-2.908 c-0.597-0.973,0.067-6.027-0.741-9.953c-0.696-3.38-0.513-5.683,0.702-5.526c0.191,0.436,0.642,0.828,0.941,1.194 c0.39,0.477,0.883,0.85,1.43,1.131c0.759,0.388,1.592,0.605,2.419,0.814c1.472,0.372,2.977,0.733,4.49,0.617 c0.432-0.033,0.883-0.115,1.22-0.388c0.444-0.36,0.59-0.965,0.709-1.525c0.106-0.497,0.212-0.994,0.317-1.491 c0.058-0.27,0.118-0.548,0.272-0.778c0.183-0.273,0.478-0.448,0.766-0.608c0.908-0.507,1.883-1.003,2.456-1.872 c0.448-0.68,0.594-1.51,0.72-2.314c0.022-0.14,0.051-0.293,0.162-0.38c0.184-0.146,0.451-0.022,0.65,0.104 C263.182,358.568,263.405,358.72,263.628,358.872z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_173_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M281.202,366.832c0,0-0.459-5.86-4.74-7.513c0,0-1.376-0.673-2.388,0.254 c0,0,3.995,0.68,5.139,7.568c0,0,0.195,0.458,1.072,0.321C280.582,367.416,281.232,367.315,281.202,366.832z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_172_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M270.38,359.938c0,0-0.001-0.194,1.024-0.359 c0.737-0.119,1.181,0.159,1.181,0.159s3.188,1.474,3.64,7.599c0,0-0.044,0.736-1.015,0.915 c-0.971,0.179-1.137-0.626-1.137-0.626S273.567,361.18,270.38,359.938z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_171_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M266.92,359.979c0,0,0.19-0.364,0.948-0.341 c0.956,0.029,1.167,0.404,1.167,0.404s2.236,2.407,2.137,7.513c0,0,0.074,0.868-1.131,0.926 c-1.205,0.058-1.009-0.915-1.009-0.915S268.776,361.051,266.92,359.979z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_167_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_168_",
    style: {
      fill: "#455A64"
    },
    d: "M243.842,287.59c3.859,11.87,13.714,45.664,18.216,63.044 c0,0-8.09,7.275-18.497,6.64l-25.092-65.064l9.993-6.184L243.842,287.59z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_144_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_164_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_165_",
    style: {
      fill: "#455A64"
    },
    d: "M161.23,450.026c0.899,0,1.627-0.728,1.627-1.627v-104.59 c0-0.899-0.728-1.627-1.627-1.627c-0.899,0-1.627,0.728-1.627,1.627V448.4C159.603,449.299,160.33,450.026,161.23,450.026z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_162_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_163_",
    style: {
      fill: "#455A64"
    },
    d: "M96.519,411.957c0.648,0,1.26-0.389,1.512-1.03l32.072-81.177 c0.33-0.836-0.079-1.781-0.915-2.11c-0.833-0.334-1.779,0.078-2.11,0.915l-32.072,81.177c-0.33,0.836,0.08,1.781,0.915,2.11 C96.117,411.92,96.32,411.957,96.519,411.957z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_160_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    style: {
      fill: "#455A64"
    },
    d: "M100.371,402.207c0.432,0,0.863-0.172,1.182-0.51l59.678-63.151l59.57,62.884 c0.618,0.655,1.647,0.682,2.299,0.062c0.653-0.618,0.68-1.648,0.062-2.299L162.41,335.06c-0.307-0.324-0.734-0.508-1.18-0.508 c0,0,0,0-0.002,0c-0.447,0-0.874,0.184-1.18,0.51l-60.858,64.401c-0.618,0.653-0.588,1.683,0.065,2.299 C99.569,402.059,99.969,402.207,100.371,402.207z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_158_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_159_",
    style: {
      fill: "#455A64"
    },
    d: "M225.939,411.957c0.199,0,0.402-0.037,0.597-0.115 c0.836-0.329,1.246-1.274,0.915-2.11l-32.072-81.177c-0.33-0.837-1.276-1.249-2.11-0.915c-0.836,0.329-1.246,1.274-0.915,2.11 l32.072,81.177C224.679,411.568,225.291,411.957,225.939,411.957z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_156_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_157_",
    style: {
      fill: "#27DEBF"
    },
    d: "M226.724,307.94c1.167-6.56-4.178-11.68-14.234-18.467 c-10.055-6.786-22.912-13.513-29.135-16.369c-8.412-3.861-17.018-3.506-27.788,2.028c-14.963,7.688-59.991,34.994-59.991,34.994 s67.32,38.006,80.272,36.302c12.953-1.704,45.326-22.756,47.891-30.166C226.304,308.852,226.724,307.94,226.724,307.94z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_154_",
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_155_",
    d: "M226.724,307.94c1.167-6.56-4.178-11.68-14.234-18.467c-10.055-6.786-22.912-13.513-29.135-16.369 c-8.412-3.861-17.018-3.506-27.788,2.028c-14.963,7.688-59.991,34.994-59.991,34.994s67.32,38.006,80.272,36.302 c12.953-1.704,45.326-22.756,47.891-30.166C226.304,308.852,226.724,307.94,226.724,307.94z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_152_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_153_",
    style: {
      fill: "#27DEBF"
    },
    d: "M169.345,338.434c9.664,8.749,19.766,1.219,35.747-9.152 c18.086-11.737,21.632-21.342,21.632-21.342s0,7.196-1.349,10.569c-1.349,3.373-4.273,7.196-17.316,16.192 c-13.043,8.995-22.488,13.493-31.259,15.163l-6.919-0.956"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    style: {
      opacity: 0.5
    },
    d: "M205.092,329.282c18.086-11.737,21.632-21.342,21.632-21.342s0,7.196-1.349,10.569 c-1.349,3.373-4.272,7.196-17.316,16.192c-13.043,8.995-22.488,13.493-31.259,15.163l-6.919-0.956l-0.536-10.474 C179.009,347.183,189.111,339.653,205.092,329.282z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_149_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    style: {
      fill: "#27DEBF"
    },
    d: "M99.041,399.218l-4.955,11.422c-0.031,0.098-0.049,0.196-0.054,0.296 c-0.01,0.066-0.013,0.138-0.01,0.211c0.029,0.24,0.315,0.558,0.63,0.765c0.72,0.464,1.922,0.521,2.682,0.126 c0.278-0.146,0.459-0.329,0.548-0.524c0-0.007,0.001-0.013,0.007-0.019l0.04-0.157l4.599-10.711L99.041,399.218z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_147_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_148_",
    style: {
      fill: "#27DEBF"
    },
    d: "M223.728,399.699l4.24,11.19c0.025,0.095,0.038,0.191,0.038,0.286 c0.006,0.063,0.006,0.133,0,0.203c-0.038,0.229-0.327,0.521-0.639,0.706c-0.712,0.413-1.869,0.413-2.581,0 c-0.261-0.152-0.426-0.337-0.502-0.528c0-0.006,0-0.013-0.006-0.019l-0.032-0.153l-3.931-10.49L223.728,399.699z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_145_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_146_",
    style: {
      fill: "#27DEBF"
    },
    d: "M159.353,440.302l0,9.256c0,0.277,0.183,0.554,0.549,0.766 c0.732,0.423,1.92,0.423,2.652,0c0.366-0.211,0.549-0.489,0.549-0.766v-9.256C161.854,439.675,160.604,439.675,159.353,440.302z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_125_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_128_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    style: {
      fill: "#37474F"
    },
    d: "M122.538,268.722c3.834,4.466,38.725-5.572,47.967-6.831 c14.908-2.031,27.045-3.515,32.103-1.924c5.058,1.59,7.209,4.169,8.76,10.229c1.829,7.148,2.776,10.79,2.776,10.79 s-24.77,9.508-44.302,11.797C150.311,295.072,122.538,268.722,122.538,268.722z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_126_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    style: {
      fill: "#455A64"
    },
    d: "M116.029,275.27c-3.868,14.735-7.343,31.879,1.609,41.265 c6.028,6.32,36.312,22.737,55.85,16.269c19.247-6.371,59.1-35.959,63.099-38.938c4.008-2.986,7.637-5.009,7.255-6.276 c-5.375-17.843-13.229-19.237-27.796-16.032c-17.812,3.918-56.919,19.878-56.919,19.878L116.029,275.27z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_122_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_123_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_124_",
    style: {
      fill: "#FFA8A7"
    },
    points: "204.52,180.519 191.083,195.713 169.379,185.415 184.552,164.421  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_117_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_120_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    style: {
      fill: "#F28F8F"
    },
    d: "M221.19,151.659c0,0,5.501,7.945,4.913,8.751 c-0.588,0.806-4.483,1.611-4.483,1.611L221.19,151.659z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.207,
      strokeMiterlimit: 10
    },
    cx: 221.147,
    cy: 150.328,
    r: 5.975
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_118_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M205.918,129.682c10.81,2.023,14.024,6.681,15.429,23.747 c1.468,17.833-0.227,23.487-2.517,25.946c-1.547,1.658-10.34,2.153-14.808,1.031c-5.592-1.405-18.25-5.567-24.337-14.415 c-7.159-10.41-9.305-24.69-2.033-30.735C187.885,126.749,201.519,128.859,205.918,129.682z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M204.52,180.519c4.652,1.051,11.726,0.416,13.827-0.79c-0.199,0.054-3.529,0.915-7.824-0.288 c-4.43-1.241-7.168-3.16-7.168-3.16L204.52,180.519z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_110_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_114_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_115_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    style: {
      fill: "#263238"
    },
    d: "M223.349,136.666c-0.01,0.007-0.021,0.014-0.031,0.021 c-3.017,2.081-6.698,2.947-10.32,3.51c0.286,2.894-0.626,5.758-1.526,8.523c-0.623,1.914-2.871,7.925-5.319,4.625 c-1.768-2.384-3.376-4.554-6.762-3.97c-5.581,0.964-6.173,8.119-2.546,12.374c3.629,4.255,6.88,2.518,6.88,2.518 s0.514,7.692-3.542,13.129c0,0-6.055,3.722-14.553,0.921c-5.363-1.767-13.103-8.529-15.955-13.807 c-7.85-14.525-7.89-28.44,1.63-32.721c0.881-6.962,6.272-10.198,12.467-11.771c8.586-2.181,17.508,3.206,25.81-0.35 c1.748-0.749,3.358-1.81,5.146-2.459c1.005-0.365,2.195-0.574,3.09,0.011c0.774,0.506,1.105,1.462,1.321,2.361 c0.396,1.653,0.549,3.501-0.326,4.958c1.253-0.604,2.529-1.214,3.902-1.438c1.373-0.223,2.883-0.008,3.945,0.889 c0.988,0.835,1.463,2.15,1.583,3.438C228.583,131.068,226.351,134.583,223.349,136.666z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_111_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_112_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    style: {
      fill: "#263238"
    },
    d: "M171.193,134.117l-6.525-3.648c1.007-1.801,3.284-2.445,5.086-1.438 C171.556,130.038,172.2,132.315,171.193,134.117z"
  })))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.027,
      strokeMiterlimit: 10
    },
    x1: 206.153,
    y1: 153.345,
    x2: 227.055,
    y2: 149.439
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M249.861,189.397c-0.563-0.942-1.813-1.125-2.849-1.486c-1.921-0.67-3.421-2.202-5.27-3.048 c-2.06-0.943-4.453-0.974-6.657-0.45c-0.759,0.181-1.5,0.423-2.224,0.711c-1.378,0.547-2.696,1.258-3.974,2.014 c-5.296,3.135-9.277,10.221-14.484,13.472c-1.94,1.212-3.753,2.312-5.539,3.407l12.437,11.088c2.562-2.084,5.007-4,6.135-4.671 c3.062-1.822,6.151-1.863,9.591-2.362c2.388-0.346,4.706-1.052,7.014-1.756c0.813-0.248,1.718-0.574,2.066-1.348 c0.442-0.982-0.332-2.165-1.334-2.56c-1.073-0.423-2.485-0.313-3.636-0.498c-0.895-0.144-3.295,0.394-3.827-0.513 c-0.278-0.474,0.067-1.059,0.41-1.488c2.157-2.69,4.885-5.572,8.338-6.38c1.071-0.251,2.187-0.508,3.037-1.205 C249.945,191.626,250.425,190.34,249.861,189.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M175.466,176.992c-13.209-7.208-25.237-2.579-29.571,6.69 c-3.921,8.388-12.165,40.844-12.165,40.844C137.692,231.956,175.466,176.992,175.466,176.992z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M173.488,179.6l1.978-2.607c-14.913-7.086-28.266,2.223-40.027,20.516 c-12.676,19.718-19.328,48.03-19.392,77.91c0,0,2.53,13.427,19.497,20.145c18,7.126,43.11,4.107,50.933-14.551 c0,0,0.158-18.635,5.826-27.811c3.667-5.937,12.219-19.135,18.581-28.6c5.538-8.239,9.842-26.99-1.729-33.85 c-3.388-2.009-4.794-2.595-9.407-4.8C189.222,189.427,172.13,183.779,173.488,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "#FFFFFF"
    },
    d: "M173.533,179.667l1.933-2.674c-14.913-7.086-28.266,2.223-40.027,20.516 c-12.676,19.718-19.328,48.03-19.392,77.91c0,0,2.53,13.427,19.497,20.145c18,7.126,43.11,4.107,50.933-14.551 c0,0,0.158-18.635,5.826-27.811c3.667-5.937,12.219-19.135,18.581-28.6c5.538-8.239,9.842-26.99-1.729-33.85 c-3.388-2.009-4.794-2.595-9.407-4.8C189.222,189.427,172.175,183.846,173.533,179.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#27DEBF"
    },
    d: "M215.699,212.653c0.764-3.592,1.024-7.373,0.464-10.86c0,0,0,0,0,0 c-2.705,6.336-6.518,12.202-11.262,17.199c-6.069,6.392-13.564,11.37-19.195,18.151c-5.963,7.182-10.25,15.866-15.243,23.711 c-2.004,3.148-4.74,9.22-8.464,9.463c-4.539,0.295-8.878-5.237-11.353-9.053c-3.949-6.088-7.34-13.692-12.249-19.035 c-4.29-4.669-10.925-10.65-16.769-7.94h0c-0.437,1.55-0.848,3.12-1.235,4.706c-0.392,1.603-0.755,3.213-1.092,4.828 c-0.013,0.062-0.026,0.124-0.038,0.186c-0.336,1.623-0.645,3.251-0.927,4.884c-0.015,0.087-0.029,0.174-0.044,0.261 c-0.276,1.616-0.527,3.237-0.752,4.861c-0.965,6.987-1.476,14.165-1.491,21.405c0,0,2.531,13.427,19.497,20.145 c18,7.126,43.11,4.107,50.934-14.551c0,0,0.157-18.635,5.826-27.811c0.57-0.922,1.268-2.036,2.047-3.267 c0.003-0.005,0.005-0.009,0.007-0.013c0.044-0.07,0.089-0.139,0.133-0.209c0.648-1.023,1.353-2.131,2.107-3.308 c0.046-0.072,0.092-0.145,0.138-0.217c0.019-0.03,0.039-0.059,0.058-0.089c1.618-2.525,3.434-5.333,5.314-8.216 c0.285-0.437,0.57-0.874,0.856-1.312c1.815-2.777,3.665-5.586,5.428-8.239c0.006-0.009,0.012-0.019,0.019-0.028 c0.596-0.896,1.175-1.764,1.746-2.616c0.244-0.364,0.49-0.733,0.729-1.087c0.002-0.002,0.003-0.005,0.005-0.008 c0.2-0.298,0.397-0.612,0.593-0.935c0.059-0.097,0.117-0.198,0.175-0.298c0.142-0.242,0.282-0.489,0.421-0.743 c0.061-0.111,0.122-0.223,0.182-0.337c0.151-0.286,0.3-0.579,0.447-0.88c0.038-0.077,0.076-0.151,0.113-0.229 c0.188-0.392,0.373-0.795,0.552-1.208c0.007-0.016,0.013-0.032,0.02-0.048c0.01-0.024,0.02-0.048,0.03-0.072 c0.16-0.372,0.315-0.752,0.466-1.139c0.036-0.092,0.071-0.185,0.106-0.278c0.139-0.366,0.275-0.737,0.405-1.114 c0.01-0.029,0.02-0.059,0.031-0.088c0.014-0.042,0.029-0.083,0.043-0.124c0.237-0.696,0.457-1.409,0.659-2.135 c0.002-0.005,0.003-0.011,0.005-0.016c0.202-0.727,0.385-1.467,0.546-2.216c0.001-0.007,0.003-0.013,0.004-0.02 C215.69,212.695,215.694,212.674,215.699,212.653z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M284.891,230.802c-0.93,1.154-1.999,2.203-3.099,3.2c-4.562,4.132-9.893,6.114-16.089,10.138 c-5.009,3.253-12.733,7.991-19.242,12.048c-7.316,4.561-16.139,8.268-20.952,9.682c-6.048,1.777-9.432,1.852-13.008-7.835 c-1.754-4.75-3.143-9.625-4.657-14.457c-2.253-7.191-4.467-14.395-6.643-21.61c0,0-8.042-19.829,9.95-29.788 c7.829,4.48,10.812,6.294,13.268,15.671c2.936,11.226,7.696,33.384,7.696,33.384c6.364-2.197,12.57-4.919,18.596-7.915 c2.283-1.135,5.09-1.923,6.719-3.954c1.107-1.38,2.005-2.909,2.861-4.453c0.766-1.382,1.32-2.885,2.164-4.206 c1.567-2.452,3.829-4.512,5.913-6.513c0.408-0.392,0.865-0.807,1.43-0.847c0.596-0.043,1.154,0.367,1.451,0.885 c0.663,1.154,0.047,2.287-0.292,3.468c-0.386,1.347-0.773,2.693-1.159,4.04c4.595-2.721,8.491-6.296,11.477-10.76 c0.272-0.406,0.54-0.823,0.905-1.147c0.366-0.324,0.85-0.549,1.335-0.489c1.205,0.15,2.398,2.094,2.458,3.205 c0.061,1.131-0.191,2.289,0.089,3.387c0.267,1.046,0.976,1.904,1.304,2.925c0.321,0.999,0.577,2.189,0.686,3.238 c0.252,2.432-0.606,4.723-1.826,6.786C285.831,229.56,285.38,230.196,284.891,230.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M210.076,191.35c6.858,2.772,11.793,5.903,14.919,16.361c3.143,10.517,6.516,27.241,6.516,27.241 s0.064,3.51-8.258,8.417c-8.322,4.907-16.108,2.171-16.108,2.171l-6.285-20.197C200.859,225.342,189.717,198.329,210.076,191.35 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_105_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    style: {
      fill: "#27DEBF"
    },
    d: "M169.881,348.908c-5.503-0.277-9.81-4.317-22.895-9.769 c-24.16-10.067-42.28-18.12-49.183-30.775C90.9,295.708,86.01,259.18,87.736,243.361c0.229-2.099,0.637-3.824,1.183-5.244 l-1.699-0.249l4.401-3.746l0.002,0.011c4.514-3.687,11.861-0.4,17.397,2.613c15.817,8.608,28.187,16.97,37.966,47.17 c7.356,22.716,12.207,43.438,22.359,54.519"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    style: {
      opacity: 0.3
    },
    d: "M88.919,238.117l-1.699-0.249l4.401-3.746l0.002,0.011 c4.514-3.687,11.861-0.4,17.397,2.613c15.817,8.608,28.187,16.97,37.966,47.17c7.356,22.716,12.207,43.438,22.359,54.519 l0.536,10.474c-5.503-0.277-9.81-4.317-22.895-9.769c-24.16-10.067-42.28-18.12-49.183-30.775 C90.9,295.708,86.01,259.18,87.736,243.361C87.965,241.262,88.373,239.537,88.919,238.117z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_106_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    style: {
      fill: "#27DEBF"
    },
    d: "M104.436,240.635c15.817,8.608,28.187,16.97,37.966,47.17 c9.779,30.2,15.128,56.882,34.398,62.059c0,0-8.713,3.463-35.415-7.831c-8.496-3.593-18.805-10.145-25.579-13.946 c-13.271-7.448-21.316-13.551-22.588-15.834c-7.015-12.594-11.793-49.183-10.067-65.002 C84.878,231.432,96.515,236.324,104.436,240.635z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3721_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3751_",
    style: {
      fill: "#27DEBF"
    },
    d: "M193.338,106.694l-4.369-8.215l3.515-10.146v-6.211l-10.757,6.211v6.211 l4.625,8.01c0.078,0.135,0.19,0.224,0.314,0.279l-0.003,0.004L193.338,106.694z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3749_",
    style: {
      opacity: 0.2
    },
    d: "M193.338,106.694l-4.369-8.215l3.515-10.146v-6.211l-10.757,6.211v6.211 l4.625,8.01c0.078,0.135,0.19,0.224,0.314,0.279l-0.003,0.004L193.338,106.694z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3747_",
    style: {
      fill: "#27DEBF"
    },
    d: "M219.027,32.749c0-2.057-1.444-4.558-3.225-5.586l-2.626-1.516 c-1.781-1.028-4.669-1.028-6.45,0l-40.273,23.293c-1.781,1.029-3.225,3.529-3.225,5.586v44.311c0,2.057,1.445,4.558,3.225,5.587 l2.626,1.516c1.781,1.028,4.669,1.028,6.451,0l12.952-7.483l4.615,7.994c0.295,0.511,1.054,0.438,1.247-0.119l4.878-14.081 l16.58-9.605c1.781-1.028,3.225-3.529,3.225-5.586L219.027,32.749z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3727_",
    style: {
      opacity: 0.2
    },
    d: "M163.228,98.837c0,2.057,1.444,4.558,3.225,5.586l2.626,1.516 c1.61,0.929,4.115,1.01,5.899,0.26c-1.518,0.574-2.674-0.283-2.674-2.122l-0.001-44.312c0-1.028,0.361-2.168,0.944-3.179 l-9.076-5.24c-0.584,1.011-0.944,2.15-0.944,3.179V98.837z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3723_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M218.922,31.832c-0.376-1.369-1.625-1.806-3.114-0.948 l-40.28,23.298c-0.888,0.512-1.7,1.384-2.272,2.407l-9.073-5.236c0.587-1.023,1.384-1.896,2.272-2.408l40.265-23.299 c1.79-1.023,4.679-1.023,6.455,0l2.633,1.52C217.327,28.041,218.606,29.996,218.922,31.832z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C__x2F__x3E__2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M178.225,77.165c0-0.359,0.056-0.666,0.165-0.92c0.109-0.254,0.266-0.541,0.47-0.861l8.756-14.156 c0.058-0.077,0.105-0.133,0.142-0.167c0.037-0.032,0.069-0.056,0.099-0.073c0.131-0.076,0.24-0.072,0.327,0.013 c0.088,0.084,0.132,0.228,0.132,0.43v5.46c0,0.449-0.085,0.828-0.252,1.139c-0.168,0.311-0.317,0.56-0.448,0.748l-4.515,6.886 l4.515,2.075c0.131,0.037,0.281,0.109,0.448,0.214c0.168,0.105,0.252,0.383,0.252,0.832v3.878c0,0.202-0.044,0.396-0.132,0.582 c-0.087,0.185-0.196,0.315-0.327,0.391c-0.031,0.017-0.063,0.03-0.099,0.04c-0.037,0.01-0.085,0.01-0.142-0.003l-8.756-4.044 c-0.205-0.084-0.361-0.19-0.47-0.318c-0.109-0.127-0.165-0.37-0.165-0.73V77.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M197.313,55.297c0.073-0.288,0.182-0.582,0.328-0.88c0.146-0.298,0.358-0.526,0.636-0.687 l2.933-1.694c0.131-0.076,0.244-0.067,0.339,0.023c0.094,0.091,0.142,0.237,0.142,0.44c0,0.091-0.015,0.2-0.044,0.33 l-7.399,31.535c-0.057,0.258-0.159,0.542-0.306,0.851c-0.146,0.309-0.365,0.549-0.656,0.717l-2.868,1.656 c-0.13,0.075-0.244,0.067-0.338-0.024c-0.096-0.092-0.143-0.238-0.143-0.44c0-0.089,0.015-0.2,0.045-0.328L197.313,55.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M213.403,60.399c0,0.36-0.055,0.667-0.164,0.92c-0.11,0.254-0.267,0.542-0.471,0.862 l-8.756,14.154c-0.058,0.079-0.105,0.135-0.142,0.167c-0.035,0.032-0.069,0.057-0.098,0.074 c-0.132,0.076-0.241,0.072-0.328-0.013c-0.088-0.084-0.131-0.228-0.131-0.43v-5.46c0-0.449,0.083-0.824,0.251-1.122 c0.168-0.299,0.318-0.544,0.448-0.732l3.831-5.919l-3.831-1.461c-0.13-0.037-0.281-0.113-0.448-0.23 c-0.168-0.118-0.251-0.4-0.251-0.849v-5.459c0-0.202,0.043-0.396,0.131-0.582c0.087-0.185,0.196-0.315,0.328-0.391 c0.029-0.017,0.062-0.031,0.098-0.041c0.037-0.009,0.085-0.008,0.142,0.002l8.756,4.045c0.205,0.084,0.361,0.189,0.471,0.317 c0.109,0.128,0.164,0.372,0.164,0.73V60.399z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Text_Boxes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text_Box_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x7B__x7D__3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speach_Bubble_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_96_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_98_",
    style: {
      fill: "#263238"
    },
    d: "M96.495,27.204L42.607,58.248c-0.738,0.426-1.338,1.463-1.338,2.316v30.082 c0,0.853,0.603,1.882,1.345,2.302l5.319,3.024c0.743,0.419,1.943,0.413,2.682-0.013l53.889-31.044 c0.738-0.426,1.337-1.463,1.337-2.316V32.519c0-0.853-0.602-1.884-1.345-2.303l-5.319-3.024 C98.434,26.772,97.234,26.778,96.495,27.204z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    style: {
      fill: "#455A64"
    },
    d: "M105.823,32.276c-0.105-0.673-0.654-0.914-1.322-0.531L50.618,62.79 c-0.37,0.216-0.704,0.581-0.945,1l-7.984-4.592c0.241-0.402,0.562-0.747,0.92-0.951l53.89-31.045 c0.735-0.426,1.933-0.432,2.68-0.012l5.317,3.023C105.168,30.596,105.73,31.479,105.823,32.276z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M104.504,31.747L50.615,62.79c-0.738,0.426-1.337,1.463-1.337,2.316v30.081 c0,0.853,0.599,1.198,1.337,0.772l53.889-31.044c0.739-0.426,1.337-1.463,1.337-2.316V32.519 C105.841,31.666,105.242,31.32,104.504,31.747z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M62.595,70.501c-0.013,0.237-0.021,0.56-0.026,0.969c-0.006,0.41-0.009,0.831-0.009,1.264 s0.003,0.855,0.009,1.267c0.006,0.412,0.014,0.729,0.026,0.952c0.022,0.393,0.074,0.752,0.154,1.077 c0.08,0.324,0.206,0.578,0.379,0.761c0.172,0.184,0.39,0.283,0.654,0.298c0.264,0.016,0.59-0.089,0.98-0.314 c0.39-0.225,0.711-0.48,0.964-0.768c0.252-0.287,0.458-0.578,0.618-0.874c0.161-0.296,0.284-0.593,0.371-0.89 c0.086-0.297,0.151-0.564,0.197-0.803c0.058-0.315,0.12-0.551,0.189-0.706c0.069-0.154,0.201-0.288,0.396-0.4l2.254-1.301 c0.103-0.06,0.191-0.053,0.266,0.018c0.075,0.072,0.113,0.187,0.113,0.346c-0.012,0.907-0.156,1.838-0.431,2.792 c-0.275,0.954-0.654,1.861-1.136,2.722c-0.482,0.861-1.047,1.651-1.695,2.369c-0.648,0.719-1.351,1.296-2.107,1.733 c-0.826,0.477-1.563,0.713-2.212,0.708c-0.647-0.006-1.201-0.203-1.66-0.591c-0.459-0.388-0.812-0.948-1.059-1.681 c-0.246-0.732-0.387-1.574-0.421-2.525c-0.022-0.711-0.035-1.48-0.035-2.311c0-0.83,0.013-1.632,0.035-2.404 c0.023-0.985,0.16-1.987,0.413-3.007c0.252-1.02,0.605-1.988,1.059-2.903c0.452-0.915,1.006-1.751,1.66-2.508 c0.653-0.757,1.394-1.374,2.22-1.851c0.757-0.437,1.459-0.67,2.107-0.7c0.648-0.029,1.213,0.107,1.695,0.412 c0.481,0.305,0.86,0.775,1.136,1.411c0.274,0.636,0.419,1.401,0.431,2.294c0,0.159-0.038,0.319-0.113,0.476 c-0.074,0.158-0.163,0.266-0.266,0.326l-2.254,1.301c-0.195,0.113-0.327,0.132-0.396,0.057c-0.069-0.074-0.132-0.237-0.189-0.486 c-0.046-0.185-0.111-0.377-0.197-0.575c-0.087-0.197-0.21-0.351-0.371-0.462c-0.16-0.109-0.366-0.163-0.618-0.159 c-0.253,0.005-0.574,0.119-0.964,0.344c-0.391,0.226-0.717,0.498-0.98,0.818c-0.265,0.32-0.482,0.672-0.654,1.053 c-0.173,0.382-0.299,0.782-0.379,1.199C62.669,69.663,62.618,70.081,62.595,70.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M77.238,54.735c0.734-0.424,1.408-0.65,2.022-0.677c0.613-0.027,1.144,0.086,1.592,0.339 c0.447,0.254,0.797,0.618,1.049,1.09c0.252,0.473,0.384,0.988,0.396,1.546c0,0.159-0.038,0.317-0.112,0.476 c-0.075,0.158-0.158,0.263-0.249,0.316l-2.255,1.302c-0.161,0.093-0.289,0.132-0.387,0.117c-0.098-0.014-0.197-0.062-0.301-0.144 c-0.035-0.033-0.09-0.09-0.164-0.17c-0.074-0.081-0.181-0.148-0.318-0.201c-0.138-0.052-0.31-0.068-0.517-0.045 c-0.206,0.022-0.458,0.118-0.757,0.291c-0.218,0.126-0.427,0.269-0.628,0.429c-0.201,0.161-0.379,0.334-0.533,0.52 c-0.155,0.187-0.281,0.397-0.379,0.63c-0.098,0.233-0.146,0.482-0.146,0.747c0,0.265,0.055,0.455,0.164,0.567 c0.108,0.114,0.292,0.172,0.551,0.172c0.258,0.001,0.599-0.05,1.023-0.153c0.425-0.104,0.952-0.241,1.583-0.411 c0.631-0.17,1.182-0.241,1.651-0.211c0.471,0.028,0.864,0.176,1.18,0.445c0.315,0.268,0.55,0.662,0.705,1.182 c0.154,0.52,0.232,1.195,0.232,2.025c0,0.901-0.132,1.781-0.396,2.64c-0.264,0.859-0.635,1.678-1.11,2.455 c-0.476,0.779-1.038,1.487-1.686,2.126c-0.649,0.64-1.356,1.181-2.126,1.624c-0.78,0.451-1.49,0.703-2.134,0.755 c-0.643,0.053-1.195-0.047-1.66-0.3c-0.465-0.252-0.828-0.629-1.093-1.131c-0.265-0.501-0.401-1.084-0.413-1.748 c0-0.159,0.037-0.317,0.112-0.476c0.074-0.157,0.157-0.263,0.25-0.316l2.254-1.301c0.16-0.093,0.286-0.134,0.379-0.126 c0.091,0.009,0.183,0.049,0.275,0.12c0.046,0.044,0.115,0.119,0.206,0.225c0.093,0.106,0.216,0.199,0.371,0.276 c0.154,0.079,0.349,0.113,0.584,0.1c0.235-0.012,0.525-0.118,0.869-0.316c0.608-0.351,1.116-0.746,1.523-1.184 c0.407-0.438,0.61-0.922,0.61-1.452c0-0.265-0.074-0.442-0.224-0.533c-0.149-0.091-0.373-0.125-0.671-0.103 c-0.299,0.022-0.68,0.097-1.145,0.223c-0.464,0.127-1.012,0.267-1.643,0.419c-1.182,0.293-2.045,0.143-2.59-0.452 c-0.546-0.595-0.818-1.652-0.818-3.17c0-0.76,0.113-1.549,0.336-2.367c0.225-0.818,0.548-1.614,0.973-2.39 c0.424-0.774,0.938-1.49,1.54-2.147C75.819,55.708,76.492,55.166,77.238,54.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M89.696,47.542c0.734-0.424,1.408-0.65,2.022-0.677c0.613-0.027,1.145,0.085,1.592,0.339 c0.447,0.254,0.798,0.618,1.05,1.09c0.252,0.473,0.384,0.988,0.396,1.546c0,0.159-0.037,0.317-0.111,0.476 c-0.075,0.158-0.158,0.263-0.25,0.316l-2.255,1.302c-0.16,0.093-0.289,0.132-0.386,0.117c-0.099-0.014-0.198-0.062-0.302-0.144 c-0.034-0.033-0.09-0.09-0.164-0.17c-0.074-0.081-0.18-0.148-0.317-0.201c-0.139-0.052-0.31-0.068-0.518-0.045 c-0.206,0.021-0.458,0.118-0.757,0.291c-0.218,0.126-0.427,0.269-0.627,0.429c-0.201,0.161-0.379,0.334-0.534,0.52 c-0.154,0.187-0.281,0.397-0.379,0.63c-0.097,0.233-0.146,0.482-0.146,0.747c0,0.265,0.055,0.455,0.164,0.567 c0.107,0.114,0.291,0.172,0.55,0.172c0.258,0.001,0.599-0.05,1.023-0.153c0.425-0.103,0.952-0.241,1.583-0.411 c0.631-0.17,1.182-0.241,1.652-0.211c0.47,0.028,0.863,0.176,1.179,0.445c0.315,0.268,0.551,0.662,0.705,1.182 c0.155,0.52,0.232,1.195,0.232,2.025c0,0.901-0.132,1.781-0.396,2.64c-0.264,0.859-0.634,1.678-1.109,2.455 c-0.477,0.779-1.039,1.487-1.687,2.126c-0.648,0.64-1.356,1.181-2.125,1.624c-0.781,0.451-1.491,0.703-2.134,0.755 c-0.643,0.053-1.196-0.047-1.66-0.3c-0.466-0.252-0.829-0.629-1.093-1.131c-0.265-0.501-0.402-1.084-0.414-1.748 c0-0.159,0.037-0.317,0.113-0.476c0.074-0.157,0.157-0.263,0.249-0.316l2.254-1.301c0.161-0.093,0.287-0.134,0.379-0.126 c0.091,0.009,0.183,0.049,0.274,0.12c0.046,0.044,0.115,0.119,0.207,0.225c0.092,0.106,0.216,0.199,0.37,0.276 c0.155,0.079,0.35,0.113,0.584,0.1c0.235-0.012,0.525-0.118,0.87-0.316c0.607-0.351,1.115-0.746,1.522-1.184 c0.407-0.438,0.611-0.922,0.611-1.452c0-0.265-0.074-0.442-0.225-0.533c-0.148-0.091-0.373-0.125-0.671-0.103 c-0.298,0.022-0.68,0.097-1.144,0.223c-0.465,0.127-1.013,0.267-1.644,0.419c-1.182,0.293-2.045,0.143-2.59-0.452 c-0.545-0.595-0.817-1.652-0.817-3.17c0-0.76,0.112-1.549,0.336-2.367c0.224-0.818,0.548-1.614,0.973-2.39 c0.423-0.774,0.937-1.49,1.54-2.147C88.277,48.516,88.951,47.973,89.696,47.542z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Text_Box_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x7B__x7D__2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speach_Bubble_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    style: {
      fill: "#263238"
    },
    d: "M96.495,89.718l-53.889,31.044c-0.738,0.426-1.338,1.463-1.338,2.316v30.082 c0,0.853,0.603,1.882,1.345,2.302l5.319,3.024c0.743,0.419,1.943,0.413,2.682-0.013l53.889-31.044 c0.738-0.426,1.337-1.463,1.337-2.316V95.032c0-0.852-0.602-1.884-1.345-2.303l-5.319-3.024 C98.434,89.286,97.234,89.292,96.495,89.718z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    style: {
      fill: "#455A64"
    },
    d: "M105.823,94.79c-0.105-0.673-0.654-0.914-1.322-0.531l-53.884,31.045 c-0.37,0.216-0.704,0.58-0.945,1l-7.984-4.592c0.241-0.401,0.562-0.747,0.92-0.951l53.89-31.045 c0.735-0.426,1.933-0.432,2.68-0.012l5.317,3.023C105.168,93.11,105.73,93.993,105.823,94.79z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M104.504,94.26l-53.889,31.044c-0.738,0.426-1.337,1.463-1.337,2.316V157.7 c0,0.853,0.599,1.198,1.337,0.772l53.889-31.044c0.739-0.426,1.337-1.463,1.337-2.316V95.032 C105.841,94.179,105.242,93.834,104.504,94.26z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M62.853,125.818c0.126-0.073,0.235-0.064,0.326,0.023c0.092,0.088,0.138,0.23,0.138,0.424v17.114 c0,0.194-0.046,0.388-0.138,0.583c-0.091,0.194-0.2,0.328-0.326,0.4l-2.255,1.302c-0.126,0.073-0.235,0.066-0.326-0.023 c-0.093-0.088-0.139-0.229-0.139-0.423v-6.491l-3.819,2.206v6.491c0,0.194-0.046,0.388-0.139,0.583 c-0.091,0.194-0.2,0.328-0.326,0.4l-2.254,1.301c-0.127,0.073-0.235,0.07-0.327-0.009c-0.092-0.08-0.138-0.225-0.138-0.437 v-17.114c0-0.194,0.046-0.389,0.138-0.584c0.092-0.193,0.2-0.328,0.327-0.401l2.254-1.301c0.126-0.073,0.235-0.064,0.326,0.023 c0.093,0.088,0.139,0.23,0.139,0.424v6.385l3.819-2.206v-6.385c0-0.194,0.046-0.389,0.139-0.584c0.091-0.193,0.2-0.328,0.326-0.4 L62.853,125.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M75.431,118.556c0.126-0.073,0.235-0.064,0.327,0.023c0.092,0.089,0.138,0.23,0.138,0.425v2.808 c0,0.194-0.046,0.389-0.138,0.583c-0.092,0.195-0.201,0.328-0.327,0.401l-3.028,1.748v13.591c0,0.194-0.046,0.388-0.138,0.583 c-0.092,0.194-0.2,0.328-0.327,0.4l-2.253,1.301c-0.127,0.073-0.236,0.066-0.328-0.023c-0.092-0.088-0.138-0.229-0.138-0.423 v-13.591l-3.028,1.749c-0.126,0.073-0.235,0.065-0.326-0.023c-0.093-0.088-0.138-0.23-0.138-0.424v-2.808 c0-0.194,0.045-0.389,0.138-0.584c0.091-0.193,0.2-0.328,0.326-0.4L75.431,118.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M83.337,127.861c-0.098-0.094-0.175-0.195-0.232-0.304l-1.617-3.437v8.77 c0,0.194-0.046,0.388-0.138,0.583c-0.092,0.194-0.201,0.328-0.327,0.4l-2.254,1.301c-0.127,0.073-0.235,0.066-0.327-0.023 c-0.092-0.088-0.138-0.229-0.138-0.423v-17.114c0-0.194,0.046-0.389,0.138-0.583c0.092-0.193,0.2-0.328,0.327-0.401l1.996-1.152 c0.229-0.132,0.401-0.134,0.516-0.006c0.115,0.128,0.189,0.226,0.225,0.294l2.787,5.729l2.788-8.947 c0.033-0.108,0.109-0.293,0.223-0.553c0.115-0.261,0.287-0.458,0.518-0.59l1.995-1.152c0.126-0.073,0.235-0.064,0.327,0.023 c0.092,0.088,0.138,0.23,0.138,0.424v17.114c0,0.194-0.046,0.388-0.138,0.582c-0.092,0.194-0.201,0.328-0.327,0.4l-2.254,1.302 c-0.126,0.073-0.235,0.065-0.327-0.023c-0.092-0.088-0.138-0.229-0.138-0.423v-8.77l-1.617,5.305 c-0.058,0.175-0.135,0.365-0.232,0.572c-0.098,0.207-0.232,0.359-0.404,0.458l-1.101,0.636 C83.57,127.951,83.435,127.955,83.337,127.861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M101.982,117.533c0.126-0.073,0.235-0.064,0.326,0.023c0.093,0.088,0.139,0.23,0.139,0.424v2.809 c0,0.194-0.046,0.388-0.139,0.582c-0.091,0.194-0.2,0.328-0.326,0.4l-7.967,4.6c-0.127,0.073-0.235,0.066-0.327-0.023 c-0.092-0.088-0.138-0.229-0.138-0.423v-17.114c0-0.194,0.046-0.389,0.138-0.583c0.092-0.193,0.2-0.328,0.327-0.401l2.254-1.301 c0.126-0.073,0.235-0.064,0.326,0.023c0.093,0.088,0.139,0.23,0.139,0.424v13.59L101.982,117.533z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Text_Box_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x7B__x7D__1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speach_Bubble_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    style: {
      fill: "#263238"
    },
    d: "M96.495,152.232l-53.889,31.044c-0.738,0.426-1.338,1.463-1.338,2.316v30.082 c0,0.853,0.603,1.882,1.345,2.301l5.319,3.024c0.743,0.419,1.943,0.413,2.682-0.013l53.889-31.044 c0.738-0.426,1.337-1.463,1.337-2.316v-30.081c0-0.852-0.602-1.884-1.345-2.303l-5.319-3.024 C98.434,151.799,97.234,151.805,96.495,152.232z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    style: {
      fill: "#455A64"
    },
    d: "M105.823,157.303c-0.105-0.673-0.654-0.914-1.322-0.531l-53.884,31.045 c-0.37,0.216-0.704,0.58-0.945,1l-7.984-4.592c0.241-0.402,0.562-0.747,0.92-0.951l53.89-31.045 c0.735-0.426,1.933-0.432,2.68-0.013l5.317,3.023C105.168,155.623,105.73,156.507,105.823,157.303z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M104.504,156.774l-53.889,31.044c-0.738,0.426-1.337,1.463-1.337,2.316v30.081 c0,0.853,0.599,1.198,1.337,0.772l53.889-31.044c0.739-0.426,1.337-1.463,1.337-2.316v-30.081 C105.841,156.693,105.242,156.348,104.504,156.774z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M63.644,194.922c-0.012,0.237-0.02,0.559-0.025,0.969c-0.007,0.41-0.009,0.831-0.009,1.264 s0.002,0.855,0.009,1.267c0.006,0.412,0.014,0.729,0.025,0.952c0.023,0.393,0.075,0.752,0.155,1.077 c0.08,0.324,0.206,0.578,0.379,0.761c0.172,0.184,0.39,0.283,0.653,0.298c0.264,0.016,0.591-0.089,0.982-0.314 c0.39-0.225,0.71-0.48,0.963-0.768c0.252-0.287,0.459-0.578,0.619-0.874c0.161-0.296,0.284-0.593,0.371-0.89 c0.086-0.297,0.151-0.564,0.197-0.803c0.058-0.315,0.12-0.551,0.189-0.706c0.068-0.154,0.2-0.288,0.396-0.4l2.254-1.301 c0.104-0.06,0.192-0.053,0.267,0.018c0.074,0.072,0.112,0.187,0.112,0.346c-0.012,0.907-0.155,1.838-0.43,2.791 c-0.276,0.954-0.654,1.861-1.137,2.722c-0.481,0.861-1.047,1.651-1.694,2.369c-0.648,0.719-1.351,1.296-2.107,1.733 c-0.826,0.477-1.564,0.713-2.212,0.708c-0.647-0.006-1.201-0.203-1.66-0.591c-0.459-0.388-0.812-0.948-1.059-1.681 c-0.246-0.732-0.387-1.574-0.421-2.525c-0.023-0.711-0.035-1.48-0.035-2.311c0-0.83,0.012-1.632,0.035-2.404 c0.022-0.985,0.16-1.987,0.412-3.007c0.252-1.02,0.605-1.988,1.06-2.903c0.452-0.915,1.006-1.751,1.66-2.508 c0.653-0.757,1.394-1.374,2.22-1.851c0.757-0.437,1.459-0.67,2.107-0.7c0.647-0.029,1.213,0.107,1.694,0.412 c0.482,0.305,0.86,0.775,1.137,1.411c0.274,0.636,0.418,1.401,0.43,2.294c0,0.159-0.038,0.319-0.112,0.476 c-0.074,0.158-0.163,0.266-0.267,0.326l-2.254,1.301c-0.195,0.113-0.327,0.132-0.396,0.057c-0.069-0.074-0.132-0.237-0.189-0.486 c-0.046-0.185-0.111-0.377-0.197-0.575c-0.087-0.197-0.21-0.351-0.371-0.462c-0.16-0.109-0.367-0.163-0.619-0.159 c-0.253,0.005-0.573,0.119-0.963,0.344c-0.391,0.226-0.718,0.498-0.982,0.818c-0.264,0.32-0.481,0.672-0.653,1.053 c-0.173,0.382-0.299,0.782-0.379,1.199C63.719,194.084,63.667,194.502,63.644,194.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M79.44,191.392v4.372c0,0.194-0.046,0.388-0.137,0.582c-0.093,0.195-0.201,0.328-0.327,0.401 l-2.169,1.252c-0.126,0.073-0.235,0.066-0.326-0.023c-0.093-0.088-0.138-0.229-0.138-0.423v-4.372l-2.668,1.54 c-0.126,0.073-0.234,0.065-0.326-0.023c-0.092-0.087-0.138-0.229-0.138-0.423v-2.676c0-0.194,0.046-0.389,0.138-0.583 c0.092-0.194,0.2-0.329,0.326-0.401l2.668-1.54v-4.371c0-0.193,0.045-0.388,0.138-0.583c0.091-0.194,0.2-0.328,0.326-0.4 l2.169-1.252c0.126-0.073,0.234-0.066,0.327,0.023c0.091,0.089,0.137,0.23,0.137,0.424v4.371l2.65-1.53 c0.126-0.073,0.235-0.064,0.327,0.024c0.092,0.087,0.138,0.229,0.138,0.423v2.676c0,0.194-0.046,0.389-0.138,0.582 c-0.092,0.194-0.201,0.328-0.327,0.4L79.44,191.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M90.849,184.805v4.372c0,0.194-0.046,0.388-0.137,0.582c-0.093,0.195-0.202,0.328-0.328,0.401 l-2.168,1.252c-0.126,0.073-0.235,0.065-0.326-0.023c-0.093-0.088-0.139-0.229-0.139-0.423v-4.372l-2.667,1.54 c-0.126,0.073-0.235,0.065-0.326-0.023c-0.093-0.087-0.138-0.229-0.138-0.423v-2.676c0-0.194,0.045-0.389,0.138-0.582 c0.091-0.194,0.2-0.329,0.326-0.401l2.667-1.54v-4.371c0-0.193,0.046-0.388,0.139-0.583c0.091-0.194,0.2-0.328,0.326-0.4 l2.168-1.252c0.126-0.073,0.235-0.066,0.328,0.023c0.091,0.089,0.137,0.23,0.137,0.424v4.371l2.65-1.53 c0.126-0.073,0.235-0.064,0.326,0.024c0.093,0.087,0.138,0.229,0.138,0.423v2.676c0,0.194-0.045,0.389-0.138,0.582 c-0.091,0.194-0.2,0.328-0.326,0.4L90.849,184.805z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevBanner);
export default __webpack_public_path__ + "static/media/web-dev-banner.73c75ebff760a509b6f1e1593e2dfcaf.svg";
export { ForwardRef as ReactComponent };